document.addEventListener('DOMContentLoaded', function() {
   // Scope the overlay fix to size charts on PDPs with the upsell section.
  if (document.querySelector('.template-product .master-bundle-products[data-single-product-mode="true"]')) {
    document.body.classList.add('pdp-upsell-size-charts');
    document.querySelectorAll('.template-product modal-dialog.pdp-size-chart-modal').forEach((modal) => {
      if (modal.parentElement !== document.body) document.body.appendChild(modal);
    });
  }

  // Helper function to get color selector type from data attribute
  function getColorSelectorType() {
    const bundleProductsEl = document.querySelector('bundle-products');
    return bundleProductsEl ? (bundleProductsEl.getAttribute('data-color-selector-type') || 'one_color') : 'one_color';
  }

  // When true, do not apply JS "display:none" filtering for bundle products.
  // This is useful for pages configured to show only one product.
  function isSingleProductModeEnabled() {
    const bundleProductsEl = document.querySelector('bundle-products');
    if (!bundleProductsEl) return false;
    const raw = (bundleProductsEl.getAttribute('data-single-product-mode') || '').toLowerCase().trim();
    return raw === 'true' || raw === '1' || raw === 'yes';
    // console.log('isSingleProductModeEnabled');
    // console.log(raw);
    // console.log(bundleProductsEl);
    // console.log(bundleProductsEl.getAttribute('data-single-product-mode'));
  }

  function getCardHandles(card) {
    return {
      top: card ? (card.getAttribute('data-top-handle') || '') : '',
      bottom: card ? (card.getAttribute('data-bottom-handle') || '') : '',
      third: card ? (card.getAttribute('data-third-handle') || '') : ''
    };
  }

  function handleBelongsToCard(handle, card) {
    const h = getCardHandles(card);
    return !!handle && (handle === h.top || handle === h.bottom || handle === h.third);
  }

  function getBundleProductSide(productContainer, card) {
    if (!productContainer) return 'top';
    const h = getCardHandles(card || document.querySelector('.bundle-option-card[aria-selected="true"]'));
    const productHandle = productContainer.getAttribute('data-product-handle') || '';
    const blockId = productContainer.getAttribute('data-block-id') || '';
    if ((h.third && productHandle === h.third) || /-third$/.test(blockId)) return 'third';
    if ((h.bottom && productHandle === h.bottom) || /-bottom$/.test(blockId)) return 'bottom';
    return 'top';
  }

  function collectOneColorVariant(productEl, selectedColor) {
    if (!productEl) return null;
    if (productEl.style.display === 'none' || getComputedStyle(productEl).display === 'none') return null;
    const selectedSize = productEl.querySelector('.product-variant-size-button.selected');
    if (selectedSize) {
      const variantId = selectedSize.getAttribute('data-variant-id');
      if (variantId) return { id: variantId, quantity: 1 };
    }
    const colorInput = productEl.querySelector(`input[type="radio"][value="${selectedColor}"]`);
    if (colorInput) {
      const variantId = colorInput.getAttribute('data-variant-id');
      if (variantId) return { id: variantId, quantity: 1 };
    }
    return null;
  }

  //vars
  let totalsRaf = null;
  // Removed global discount - now using per-block discount logic
  
  // Size Chart Modal Functionality
  const handleSizeChart = () => {
    document.querySelectorAll('.size-chart-link').forEach(button => {
      button.addEventListener('click', (e) => {
        e.preventDefault(); // Prevent any default actions
        e.stopPropagation(); // Stop event from bubbling up
        
        const modalId = button.getAttribute('aria-controls');
        const modal = document.getElementById(modalId);
        if (modal) {
          modal.setAttribute('open', '');
          modal.querySelector('.size-chart-modal__close').focus();
          document.body.style.overflow = 'hidden';
          
          // Prevent any other click events from firing
          e.stopImmediatePropagation();
          return false;
        }
      }, true); // Use capture phase to ensure this handler runs first
    });

    // Close modal handlers
    const closeModal = (modal) => {
      if (modal) {
        modal.removeAttribute('open');
        document.body.style.overflow = '';
      }
    };

    // Close button click
    document.querySelectorAll('.size-chart-modal__close').forEach(button => {
      button.addEventListener('click', (e) => {
        e.preventDefault();
        e.stopPropagation();
        closeModal(button.closest('modal-dialog'));
      });
    });

    // Click outside modal
    document.querySelectorAll('modal-dialog').forEach(modal => {
      modal.addEventListener('click', (e) => {
        if (e.target === modal) {
          e.preventDefault();
          e.stopPropagation();
          closeModal(modal);
        }
      });
    });

    // Escape key press
    document.addEventListener('keyup', (e) => {
      if (e.key === 'Escape') {
        const openModal = document.querySelector('modal-dialog[open]');
        closeModal(openModal);
      }
    });
  };

  // Initialize size chart functionality
  handleSizeChart();

  /**
   * Mobile-only: show the existing rating + selected summary under the option cards.
   *
   * Why we "move" the elements instead of duplicating them?
   * - `#bundle-selected-summary` contains IDs used by JS updates (price/save/compare).
   * - Duplicating it would create duplicate IDs and can break the UI updates.
   */
  function moveTwoColorSummaryUnderCardsOnMobile() {
    // Only relevant for the Master Bundle section.
    const masterBundle = document.querySelector('.master-bundle-products');
    if (!masterBundle) return;

    // Run for both one_color and two_color selector (same Figma design).
    const bundleRoot = masterBundle.querySelector('bundle-products[data-color-selector-type="two_color"]') || masterBundle.querySelector('bundle-products[data-color-selector-type="one_color"]');
    if (!bundleRoot) return;

    // The "slot" we added in Liquid right below the option cards.
    const mobileSlot = bundleRoot.querySelector('[data-bundle-mobile-summary-slot]');

    // The existing elements we want to reposition on mobile.
    const summary = bundleRoot.querySelector('#bundle-selected-summary');
    const rating = bundleRoot.querySelector('.bundle-selected-summary__rating'); // may be missing if rating disabled

    if (!mobileSlot || !summary) return;

    // Remember where these elements originally live, so we can put them back on desktop.
    const summaryHome = summary.parentNode;
    const summaryHomeNext = summary.nextSibling;

    const ratingHome = rating ? rating.parentNode : null;
    const ratingHomeNext = rating ? rating.nextSibling : null;

    // Helper: are we on mobile right now?
    const isMobile = () => window.matchMedia('(max-width: 749px)').matches;

    // Apply placement based on screen size.
    const place = () => {
      if (isMobile()) {
        // Move into the slot (this keeps the same DOM nodes / IDs).
        if (rating && !mobileSlot.contains(rating)) mobileSlot.appendChild(rating);
        if (!mobileSlot.contains(summary)) mobileSlot.appendChild(summary);
      } else {
        // Put elements back to their original position for desktop.
        if (rating && ratingHome) ratingHome.insertBefore(rating, ratingHomeNext);
        if (summaryHome) summaryHome.insertBefore(summary, summaryHomeNext);
      }
    };

    // Run once on load, then run again when screen size changes.
    place();
    const mq = window.matchMedia('(max-width: 749px)');
    if (mq.addEventListener) mq.addEventListener('change', place);
    else mq.addListener(place); // older Safari fallback
  }

  moveTwoColorSummaryUnderCardsOnMobile();

  // Sticky bar: submit the real bundle form when tapped
  document.addEventListener('click', (e) => {
    const btn = e.target.closest('[data-bundle-sticky-submit]');
    if (!btn) return;

    const forms = Array.from(document.querySelectorAll('form#bundle-form'));
    const form = forms.find(f => f && f.offsetParent !== null) || forms[0];
    if (!form) return;

    // Use requestSubmit when available (triggers native validation + submit handlers)
    if (typeof form.requestSubmit === 'function') form.requestSubmit();
    else form.submit();
  });

  /**
   * Sticky bar visibility rule:
   * - Mobile only
   * - Show when `#bundle-form` has scrolled up ~70% of the viewport
   *   (i.e. form's top is at/above 30% of viewport height).
   * - Hide before reaching that point.
   */
  function setupStickyAtcVisibility() {
    const mq = window.matchMedia('(max-width: 749px)');

    let raf = null;
    const update = () => {
      raf = null;

      const bars = document.querySelectorAll('[data-bundle-sticky-atc]');
      if (!bars.length) return;

      // Desktop: always hidden (CSS already hides, but keep class clean)
      if (!mq.matches) {
        bars.forEach((b) => b.classList.remove('is-visible'));
        return;
      }

      // Find the visible bundle form (there can be multiple in the DOM).
      const forms = Array.from(document.querySelectorAll('form#bundle-form'));
      const form = forms.find(f => f && f.offsetParent !== null) || forms[0];
      if (!form) {
        bars.forEach((b) => b.classList.remove('is-visible'));
        return;
      }

      const formRect = form.getBoundingClientRect();
      const triggerLine = window.innerHeight * 0.30; // 30% from top => "scrolled up ~70%"

      // Show when the form has moved up to (or above) the trigger line.
      // This makes sticky appear earlier than waiting for the whole section to disappear.
      const shouldShow = formRect.top <= triggerLine;
      bars.forEach((b) => b.classList.toggle('is-visible', shouldShow));
    };

    const schedule = () => {
      if (raf != null) return;
      raf = requestAnimationFrame(update);
    };

    update();
    window.addEventListener('scroll', schedule, { passive: true });
    window.addEventListener('resize', schedule);
    if (mq.addEventListener) mq.addEventListener('change', schedule);
    else mq.addListener(schedule);
  }

  setupStickyAtcVisibility();

  // Track which product's gallery should be shown (last interacted)
  let __lastGalleryProductHandle = null;
  let __syncingBundleColors = false;
  // Stay on the generic bundle image until the shopper picks a colour.
  let __showGenericBundleHero = true;

  function genericBundleHeroUrl() {
    if (!__showGenericBundleHero || getColorSelectorType() !== 'two_color') return '';
    const card = document.querySelector('.bundle-option-card[aria-selected="true"]');
    return (card && card.getAttribute('data-generic-bundle-image')) || '';
  }

  function pinGalleryToTopProduct() {
    if (getColorSelectorType() !== 'two_color') return;
    const activeCard = document.querySelector('.bundle-option-card[aria-selected="true"]');
    const topHandle = activeCard ? activeCard.getAttribute('data-top-handle') : null;
    if (topHandle) {
      __lastGalleryProductHandle = topHandle;
      window.__lastInteractedProductHandle = topHandle;
    }
    updateMainImageFromActiveColor();
    rebuildBundleGallery();
  }

  // Function to get common colors between products of the ACTIVE bundle card only
  function getCommonColors() {
    let activeCard = document.querySelector('.bundle-option-card[aria-selected="true"]');
    if (!activeCard) activeCard = document.querySelector('.bundle-option-card');
    const optionId = activeCard ? activeCard.getAttribute('data-option-id') : null;
    // Scope to active card's products only - avoid intersecting across all cards (which hid most colors)
    let productsToUse = [];
    if (optionId) {
      productsToUse = Array.from(document.querySelectorAll(`bundle-product[data-parent-id="${optionId}"]`));
    }
    if (productsToUse.length === 0) {
      productsToUse = Array.from(document.querySelectorAll('bundle-product'));
    }

    const allColorValues = new Set();
    const productColors = new Map();
    productsToUse.forEach((productContainer, index) => {
      const colors = new Set();
      productContainer.querySelectorAll('input[type="radio"]').forEach(input => {
        colors.add(input.value);
      });
      productColors.set(index, colors);
      colors.forEach(color => allColorValues.add(color));
    });

    // Find colors that exist in all products of this card
    const commonColors = new Set();
    allColorValues.forEach(color => {
      let existsInAll = true;
      productColors.forEach(colors => {
        if (!colors.has(color)) existsInAll = false;
      });
      if (existsInAll) commonColors.add(color);
    });
    // If no common colors (e.g. single product), show all colors from first product
    if (commonColors.size === 0 && productColors.size > 0) {
      productColors.get(0).forEach(c => commonColors.add(c));
    }
    return commonColors;
  }

  // Function to hide/show color swatches based on common colors
  function updateColorSwatchesVisibility() {
    const commonColors = getCommonColors();
    // 1️⃣ Parse URL parameters
    const Firstparams = new URLSearchParams(window.location.search);
    const FirstunifiedColor = Firstparams.get("unified_color");
    let firstSelected = false;
    document.querySelectorAll('.variant-swatch').forEach(swatch => {
      const colorValue = swatch.querySelector('input').value;
      const input = swatch.querySelector('input');
      if (commonColors.has(colorValue)) {
        swatch.style.display = 'inline-block';
        
        // Check the color from URL if it exists
        if (FirstunifiedColor && colorValue === FirstunifiedColor) {
          input.checked = true;
          input.dispatchEvent(new Event('change', { bubbles: true }));
          // setTimeout(() => {
          // }, 500);
          firstSelected = false;
        }

        if (!firstSelected && !FirstunifiedColor) {
          const container = swatch.closest('.bundle-one-color');
          const isInVisibleUnified = container && getComputedStyle(container).display !== 'none';
          if (isInVisibleUnified) {
            input.checked = true;
            input.dispatchEvent(new Event('change', { bubbles: true }));
            firstSelected = true;
          }
        }
      } else {
        swatch.style.display = 'none';
        swatch.style.setProperty('display', 'none', 'important');
      }
    });
  }

  // Reorder unified one-color swatches based on custom color order from data-color-order
  function applyUnifiedColorOrder() {
    const containers = document.querySelectorAll('.bundle-one-color[data-color-order]');
    if (!containers.length) return;

    containers.forEach((container) => {
      const raw = (container.getAttribute('data-color-order') || '').trim();
      if (!raw) return;

      // Support both newline-separated and comma-separated lists
      const tokens = raw
        .split(/[\n,]+/)
        .map((t) => t.trim())
        .filter((t) => t.length > 0);
      if (!tokens.length) return;

      const order = tokens.map((t) => t.toLowerCase());
      const fieldset = container.querySelector('.women_color_variants');
      if (!fieldset) return;

      const swatches = Array.from(fieldset.querySelectorAll('.variant-swatch'));
      if (!swatches.length) return;

      // Stable-ish sort: colors in order[] first (by index), others afterwards in original order
      swatches.sort((a, b) => {
        const ia = swatches.indexOf(a);
        const ib = swatches.indexOf(b);
        const va = (a.querySelector('input')?.value || '').toLowerCase();
        const vb = (b.querySelector('input')?.value || '').toLowerCase();
        const oa = order.indexOf(va);
        const ob = order.indexOf(vb);
        const ra = oa === -1 ? order.length + ia : oa;
        const rb = ob === -1 ? order.length + ib : ob;
        return ra - rb;
      });

      swatches.forEach((s) => fieldset.appendChild(s));
    });
  }

  // Call this function on page load
   const color_selector_type_only = getColorSelectorType();
    if (color_selector_type_only === 'one_color') {
         applyUnifiedColorOrder();
         updateColorSwatchesVisibility();
         // Test the discount function after a short delay
         setTimeout(() => {
           console.log('Testing showDiscountAfterProductTitle...');
           showDiscountAfterProductTitle();
         }, 1000);
    }
    
    // Update SALE badges on page load
    // setTimeout(() => {
    //   updateSaleBadgesOnColorSwatches();
    // }, 1500);

  // Handle variant selection and update hidden input
  const colorSwatches = document.querySelectorAll('.variant-swatch input[type="radio"]');
  const sizeButtons = document.querySelectorAll('.product-variant-size-button');
  const productVariantIds = document.querySelectorAll('.product-variant-id');
  const bundleForm = document.getElementById('bundle-form');
  const bundleTotalsEl = document.getElementById('bundle-totals');
  const originalTotalEl = document.getElementById('bundle-total-original');
  const discountedTotalEl = document.getElementById('bundle-total-discounted');
  const discountBadgeEl = document.getElementById('bundle-discount-badge');
  const productContainers = Array.from(document.querySelectorAll('bundle-product'));

  // Function to get currently selected colors for both products
  function getSelectedColors() {
    const colors = {};
    const activeCard = document.querySelector('.bundle-option-card[aria-selected="true"]');
    if (!activeCard) return colors;
    
    const activeId = activeCard.getAttribute('data-option-id');
    const colorSelectorType = getColorSelectorType();
    
    if (colorSelectorType === 'one_color') {
      // For unified color selector
      const unifiedInput = document.querySelector('input[name="unified-color"]:checked');
      if (unifiedInput) {
        colors.unified = unifiedInput.value;
      }
    } else {
      const topProduct = document.querySelector(`bundle-product[data-parent-id="${activeId}"][data-block-id*="-top"]`);
      const bottomProduct = document.querySelector(`bundle-product[data-parent-id="${activeId}"][data-block-id*="-bottom"]`);
      const thirdProduct = document.querySelector(`bundle-product[data-parent-id="${activeId}"][data-block-id*="-third"]`);
      
      if (topProduct) {
        const topColorInput = topProduct.querySelector('input[type="radio"]:checked');
        if (topColorInput) {
          colors.top = topColorInput.value;
        }
      }
      
      if (bottomProduct) {
        const bottomColorInput = bottomProduct.querySelector('input[type="radio"]:checked');
        if (bottomColorInput) {
          colors.bottom = bottomColorInput.value;
        }
      }

      if (thirdProduct) {
        const thirdColorInput = thirdProduct.querySelector('input[type="radio"]:checked');
        if (thirdColorInput) {
          colors.third = thirdColorInput.value;
        }
      }
    }
    
    return colors;
  }

  // Function to update URL with color parameters
  function updateUrlWithColors() {
    const url = new URL(window.location.href);
    const activeCard = document.querySelector('.bundle-option-card[aria-selected="true"]');
    if (!activeCard) return;
    
    const bundleId = activeCard.getAttribute('data-option-id');
    url.searchParams.set('bundle', bundleId);
    
    // Remove existing color parameters
    url.searchParams.delete('top_color');
    url.searchParams.delete('bottom_color');
    url.searchParams.delete('third_color');
    url.searchParams.delete('unified_color');
    
    const colors = getSelectedColors();
    
    if (colors.unified) {
      url.searchParams.set('unified_color', colors.unified);
    } else {
      if (colors.top) {
        url.searchParams.set('top_color', colors.top);
      }
      if (colors.bottom) {
        url.searchParams.set('bottom_color', colors.bottom);
      }
      if (colors.third) {
        url.searchParams.set('third_color', colors.third);
      }
    }
    
    // Debug logging
    
    window.history.replaceState({}, '', url.toString());
  }

  // Tabs: show only products for the selected bundle_option and sync URL
  function setActiveBundleOption(id, updateUrl = true) {
    __showGenericBundleHero = true;

    const cards = document.querySelectorAll('.bundle-option-card');
    if (!cards.length) return;

    // Card active state
    cards.forEach(card => {
      const isActive = card.getAttribute('data-option-id') === id;
      card.setAttribute('aria-selected', isActive ? 'true' : 'false');
    });
    
    // Update SALE badges when bundle option changes
    // setTimeout(() => {
    //   updateSaleBadgesOnColorSwatches();
    // }, 100);

    // Determine handles from selected bundle_option card
    const card = document.querySelector(`.bundle-option-card[data-option-id="${id}"]`);
    const topHandle = card?.getAttribute('data-top-handle');
    const bottomHandle = card?.getAttribute('data-bottom-handle');
    if (topHandle) {
      __lastGalleryProductHandle = topHandle;
      window.__lastInteractedProductHandle = topHandle;
    }

    const singleProductMode = isSingleProductModeEnabled();

    // Show only matching products by handle (unless single product mode is enabled)
    if (!singleProductMode) {
      document.querySelectorAll('bundle-product').forEach(bp => {
        const handle = bp.getAttribute('data-product-handle');
        const parentId = bp.getAttribute('data-parent-id');
        const shouldShow = parentId == id && handleBelongsToCard(handle, card);
        bp.style.display = shouldShow ? '' : 'none';
      });
    } else {
      // Ensure products are not stuck hidden from previous runs.
      document.querySelectorAll('bundle-product').forEach(bp => {
        bp.style.display = '';
      });
    }

    document.querySelectorAll('.bundle-one-color').forEach(bp => {
      const parentId = bp.getAttribute('data-parent-id')
      const shouldShow = parentId == id ;
      bp.style.display = shouldShow ? '' : 'none';
    });
    // Ensure visual order: top product above bottom product
    if (topHandle && bottomHandle) {
      const wrapper = document.querySelector('.image-with-text__products');
      const topEl = document.querySelector(`bundle-product[data-product-handle="${topHandle}"][data-parent-id="${id}"]`);
      const bottomEl = document.querySelector(`bundle-product[data-product-handle="${bottomHandle}"][data-parent-id="${id}"]`);
      // if (wrapper && topEl && bottomEl) {
      //   // Insert top before bottom to guarantee order
      //   if (topEl.nextElementSibling !== bottomEl) {
      //     wrapper.insertBefore(topEl, bottomEl);
      //   }
      // }
    }

    // Also hide/show product_title_two_color elements that are OUTSIDE bundle-product
    if (!singleProductMode) {
      document.querySelectorAll('.product_title_two_color').forEach(titleEl => {
        // Check if this title is inside a bundle-product
        const productContainer = titleEl.closest('bundle-product');
        if (productContainer) {
          const handle = productContainer.getAttribute('data-product-handle');
          const shouldShow = handleBelongsToCard(handle, card);
          titleEl.style.display = shouldShow ? 'flex' : 'none';
        } else {
          // This title is OUTSIDE bundle-product, so we need to find its product by looking at siblings
          const nextBundleProduct = titleEl.nextElementSibling;
          if (nextBundleProduct && nextBundleProduct.tagName === 'BUNDLE-PRODUCT') {
            const handle = nextBundleProduct.getAttribute('data-product-handle');
            const parentId = nextBundleProduct.getAttribute('data-parent-id')
            const shouldShow = parentId ==id && handleBelongsToCard(handle, card);
            titleEl.style.display = shouldShow ? 'flex' : 'none';
          }
        }
      });
    } else {
      // Make sure titles are not stuck hidden.
      document.querySelectorAll('.product_title_two_color').forEach(titleEl => {
        titleEl.style.display = '';
      });
    }

    if (updateUrl) {
      // Clear color parameters from URL when switching bundles
      const url = new URL(window.location.href);
      url.searchParams.delete('top_color');
      url.searchParams.delete('bottom_color');
      url.searchParams.delete('third_color');
      url.searchParams.delete('unified_color');
      url.searchParams.set('bundle', id);
      window.history.replaceState({}, '', url.toString());
    }

    // Update bundle info display based on selected card
    updateBundleInfoDisplay(id);
    
    // Update bundle accordions based on selected card
    updateBundleAccordions(id);
    
    // Update bundle hotspots based on selected card
    updateBundleHotspots(id);
    
    // Reset original image URL for new bundle card (will be set when first image loads)
    // This ensures hotspots show on the first image of the new bundle
    originalMainImageUrls.delete(id);
    
    // Recompute totals to reflect visible products
    scheduleTotalsCompute();
    if (getColorSelectorType() === 'one_color') {
      applyUnifiedColorOrder();
      updateColorSwatchesVisibility();
    }
    ensureActiveTabSelections();
    if (getColorSelectorType() === 'two_color') {
      syncActiveTabColorAndSizes();
    } else {
      selectFirstColorForActiveTab();
    }
    updateMainImageFromActiveColor();
    rebuildBundleGallery();
    // Don't apply colors from URL when switching bundles - start fresh
    // setColorsFromUrl();
  }
  
  // Function to update bundle info display based on selected card
  function updateBundleInfoDisplay(cardId) {
    // Update the discount banner text dynamically
    const activeCard = document.querySelector(`.bundle-option-card[data-option-id="${cardId}"]`);
    if (activeCard) {
      const bundleDiscountText = activeCard.getAttribute('data-bundle_discount_text');
      const bannerTextEl = document.querySelector('.bundle-discount-banner__text');

      if (bannerTextEl) {
        const blueSpan = bannerTextEl.querySelector('.bundle-discount-banner__text--blue');
        const greenSpan = bannerTextEl.querySelector('.bundle-discount-banner__text--green');

        if (blueSpan && greenSpan) {
          if (bundleDiscountText) {
            const parts = bundleDiscountText.split(' ');
            blueSpan.textContent = parts.slice(0, 2).join(' ');
            greenSpan.textContent = parts.slice(2, 10).join(' ');
          } else {
            // Fallback to section default if this block has no custom text
            // Since we can't easily read section.settings in JS, we can store the
            // original section text in a data attribute on the root element
            const defaultText = document.querySelector('bundle-products')?.getAttribute('data-default-discount-text');
            if (defaultText) {
              const parts = defaultText.split(' ');
              blueSpan.textContent = parts.slice(0, 2).join(' ');
              greenSpan.textContent = parts.slice(2, 10).join(' ');
            }
          }
        }
      }
    }

    // Find the visible form (there can be multiple in DOM due to fallback renderer)
    const forms = Array.from(document.querySelectorAll('form#bundle-form'));
    const visibleForm = forms.find(f => f && f.offsetParent !== null) || forms[0];
    if (!visibleForm) return;

    // Dynamic info strip is inside the form
    const infoStrip = visibleForm.querySelector('[data-bundle-static-info]');
    if (!infoStrip) return;

    const item1 = visibleForm.querySelector('[data-bundle-static-info-item="1"]');
    const item2 = visibleForm.querySelector('[data-bundle-static-info-item="2"]');
    const divider = visibleForm.querySelector('[data-bundle-static-info-divider]');

    const iconImg1 = visibleForm.querySelector('[data-bundle-static-info-icon-img-1]');
    const iconHtml1 = visibleForm.querySelector('[data-bundle-static-info-icon-html-1]');
    const textEl1 = visibleForm.querySelector('[data-bundle-static-info-text-1]');

    const iconImg2 = visibleForm.querySelector('[data-bundle-static-info-icon-img-2]');
    const iconHtml2 = visibleForm.querySelector('[data-bundle-static-info-icon-html-2]');
    const textEl2 = visibleForm.querySelector('[data-bundle-static-info-text-2]');

    if (!textEl1) return;
    
    // Find the data container for this card
    const cardDataContainer = document.querySelector(`.bundle-card-info-data[data-card-id="${cardId}"]`);
    
    if (cardDataContainer) {
      // Get icon and text from the hidden data container
      const iconImageData1 = cardDataContainer.querySelector('.bundle-card-info-icon-image-url-data');
      const iconImageData2 = cardDataContainer.querySelector('.bundle-card-info-icon-2-image-url-data');
      const svgIconData1 = cardDataContainer.querySelector('.bundle-card-info-icon-data');
      const textData1 = cardDataContainer.querySelector('.bundle-card-info-text-data');
      const textData2 = cardDataContainer.querySelector('.bundle-card-info-text-2-data');

      const imageUrl1 = iconImageData1 ? (iconImageData1.getAttribute('data-url') || '').trim() : '';
      const imageUrl2 = iconImageData2 ? (iconImageData2.getAttribute('data-url') || '').trim() : '';
      const svgHtml1 = (svgIconData1 && svgIconData1.innerHTML) ? svgIconData1.innerHTML.trim() : '';
      const textHtml1 = (textData1 && textData1.innerHTML) ? textData1.innerHTML.trim() : '';
      const textHtml2 = (textData2 && textData2.innerHTML) ? textData2.innerHTML.trim() : '';

      // Item 1: icon preference image > svg > none
      if (iconImg1) {
        if (imageUrl1) {
          iconImg1.src = imageUrl1;
          iconImg1.style.display = 'block';
        } else {
          iconImg1.removeAttribute('src');
          iconImg1.style.display = 'none';
        }
      }
      if (iconHtml1) {
        if (!imageUrl1 && svgHtml1) {
          iconHtml1.innerHTML = svgHtml1;
          iconHtml1.style.display = 'inline-flex';
        } else {
          iconHtml1.innerHTML = '';
          iconHtml1.style.display = 'none';
        }
      }
      if (textEl1) textEl1.innerHTML = textHtml1 || '';

      const hasItem1 = Boolean(imageUrl1 || svgHtml1 || textHtml1);
      if (item1) item1.style.display = hasItem1 ? 'flex' : 'none';

      // Item 2: image icon + text only
      if (iconImg2) {
        if (imageUrl2) {
          iconImg2.src = imageUrl2;
          iconImg2.style.display = 'block';
        } else {
          iconImg2.removeAttribute('src');
          iconImg2.style.display = 'none';
        }
      }
      if (iconHtml2) {
        iconHtml2.innerHTML = '';
        iconHtml2.style.display = 'none';
      }
      if (textEl2) textEl2.innerHTML = textHtml2 || '';

      const hasItem2 = Boolean(imageUrl2 || textHtml2);
      if (item2) item2.style.display = hasItem2 ? 'flex' : 'none';
      if (divider) divider.style.display = (hasItem1 && hasItem2) ? 'block' : 'none';

      // Show strip if we have at least one item
      infoStrip.style.display = (hasItem1 || hasItem2) ? 'flex' : 'none';
    } else {
      // No data container found for this card, hide the strip
      infoStrip.style.display = 'none';
      if (item1) item1.style.display = 'none';
      if (item2) item2.style.display = 'none';
      if (divider) divider.style.display = 'none';
      if (iconImg1) {
        iconImg1.removeAttribute('src');
        iconImg1.style.display = 'none';
      }
      if (iconHtml1) {
        iconHtml1.innerHTML = '';
        iconHtml1.style.display = 'none';
      }
      if (textEl1) textEl1.innerHTML = '';
      if (iconImg2) {
        iconImg2.removeAttribute('src');
        iconImg2.style.display = 'none';
      }
      if (iconHtml2) {
        iconHtml2.innerHTML = '';
        iconHtml2.style.display = 'none';
      }
      if (textEl2) textEl2.innerHTML = '';
    }
  }
  
  // Function to update bundle accordions based on selected card
  function updateBundleAccordions(cardId) {
    // Hide all accordion containers
    document.querySelectorAll('.bundle-accordions-container').forEach(container => {
      container.style.display = 'none';
    });
    
    // Show accordion container for selected card
    const accordionContainer = document.querySelector(`.bundle-accordions-container[data-card-id="${cardId}"]`);
    if (accordionContainer) {
      accordionContainer.style.display = 'block';
      
      // Initialize Swiper sliders for visible accordions (lazy initialization)
      setTimeout(() => {
        initAccordionSwipers(cardId);
      }, 100);
    }
  }

  function initAccordionDragScroll(root = document) {
    if (window.innerWidth <= 749) return;

    root.querySelectorAll('.bundle-accordion-slider').forEach((sliderEl) => {
      if (sliderEl.dataset.dragScrollInitialized === 'true') return;
      sliderEl.dataset.dragScrollInitialized = 'true';

      let isPointerDown = false;
      let isDragging = false;
      let startX = 0;
      let startScrollLeft = 0;
      let pointerId = null;

      const clickableSelector = 'a, button, input, textarea, select, summary, label, [role="button"]';

      const clearDraggingState = () => {
        sliderEl.classList.remove('is-dragging');
      };

      sliderEl.addEventListener('pointerdown', (event) => {
        if (event.pointerType === 'touch') return;
        if (event.button !== 0) return;
        if (event.target.closest(clickableSelector)) return;

        isPointerDown = true;
        isDragging = false;
        pointerId = event.pointerId;
        startX = event.clientX;
        startScrollLeft = sliderEl.scrollLeft;

        sliderEl.classList.add('is-pointer-down');
        if (typeof sliderEl.setPointerCapture === 'function') {
          sliderEl.setPointerCapture(pointerId);
        }
      });

      sliderEl.addEventListener('pointermove', (event) => {
        if (!isPointerDown || event.pointerId !== pointerId) return;

        const deltaX = event.clientX - startX;
        if (!isDragging && Math.abs(deltaX) > 6) {
          isDragging = true;
          sliderEl.classList.add('is-dragging');
        }

        if (!isDragging) return;

        event.preventDefault();
        sliderEl.scrollLeft = startScrollLeft - deltaX;
      });

      const endDrag = (event) => {
        if (event && pointerId !== null && event.pointerId !== pointerId) return;

        isPointerDown = false;
        pointerId = null;
        sliderEl.classList.remove('is-pointer-down');

        window.setTimeout(() => {
          isDragging = false;
          clearDraggingState();
        }, 0);
      };

      sliderEl.addEventListener('pointerup', endDrag);
      sliderEl.addEventListener('pointercancel', endDrag);
      sliderEl.addEventListener('lostpointercapture', endDrag);

      sliderEl.addEventListener(
        'click',
        (event) => {
          if (!sliderEl.classList.contains('is-dragging')) return;
          event.preventDefault();
          event.stopPropagation();
        },
        true
      );
    });
  }
  
  // Function to initialize Swiper sliders for accordions
  function initAccordionSwipers(cardId) {
    const accordionContainer = document.querySelector(`.bundle-accordions-container[data-card-id="${cardId}"]`);
    if (!accordionContainer) return;
    
    // Find all swiper containers that need initialization
    accordionContainer.querySelectorAll('.bundle-accordion-slider').forEach(sliderEl => {
      const sliderId = sliderEl.getAttribute('id');
      if (!sliderId) return;
      
      // Check if already initialized
      if (sliderEl.classList.contains('swiper-initialized')) return;
      
      // Find the parent slider-component
      const sliderComponent = sliderEl.closest('slider-component');
      if (!sliderComponent) return;
      
      // Check if slider-component has initializeSlider method (theme's slider component)
      if (typeof sliderComponent.initializeSlider === 'function') {
        sliderComponent.initializeSlider();
      } else {
        // Fallback: manually initialize if theme component doesn't auto-initialize
        // The theme's slider-component should handle this automatically, but we ensure it
        const event = new CustomEvent('initSlider', { bubbles: true });
        sliderComponent.dispatchEvent(event);
      }

      initAccordionDragScroll(sliderEl.parentElement || accordionContainer);
    });
  }

  initAccordionDragScroll(document);
  
  // Listen for accordion open/close to initialize Swiper when opened
  document.addEventListener('toggle', function(e) {
    if (e.target.classList.contains('bundle-accordion') && e.target.open) {
      const accordionContainer = e.target.closest('.bundle-accordions-container');
      if (accordionContainer) {
        const cardId = accordionContainer.getAttribute('data-card-id');
        setTimeout(() => {
          initAccordionSwipers(cardId);
        }, 50);
      }
    }
  }, true);
  
  // Store original/main image URL per bundle option card
  const originalMainImageUrls = new Map();
  
  // Function to update bundle hotspots based on selected card
  function updateBundleHotspots(cardId) {
    const hotspotsContainer = document.getElementById('bundle-product-hotspots');
    if (!hotspotsContainer) {
      console.warn('Hotspots container not found');
      return;
    }
    
    // Clear existing hotspots
    hotspotsContainer.innerHTML = '';
    
    // Find hotspot data for this card
    const hotspotDataTemplate = document.querySelector(`.bundle-hotspot-data[data-card-id="${cardId}"]`);
    if (!hotspotDataTemplate) {
      console.log(`No hotspot data found for card ID: ${cardId}`);
      return;
    }
    
    console.log(`Found hotspot template for card: ${cardId}`, hotspotDataTemplate);
    
    // Get all hotspot items from template
    // Note: <template> elements store content in .content property (DocumentFragment)
    const hotspotItems = hotspotDataTemplate.content.querySelectorAll('.bundle-hotspot-item');
    
    console.log(`Found ${hotspotItems.length} hotspot items for card: ${cardId}`);
    
    if (hotspotItems.length === 0) {
      console.log('No hotspot items found in template');
      return;
    }
    
    // Create hotspot buttons
    hotspotItems.forEach((item) => {
      const index = item.getAttribute('data-hotspot-index');
      const horizontal = item.getAttribute('data-horizontal') || '30';
      const vertical = item.getAttribute('data-vertical') || '40';
      
      const button = document.createElement('button');
      button.type = 'button';
      button.className = 'bundle-hotspot';
      button.setAttribute('data-hotspot-index', index);
      button.style.setProperty('--hotspot-x', `${horizontal}%`);
      button.style.setProperty('--hotspot-y', `${vertical}%`);
      button.setAttribute('aria-label', `View product feature ${index}`);
      
      // Store reference to the hotspot item for slider data
      button._hotspotItem = item;
      
      const dot = document.createElement('span');
      dot.className = 'bundle-hotspot__dot';
      button.appendChild(dot);
      
      hotspotsContainer.appendChild(button);
      console.log(`Created hotspot button ${index} at position ${horizontal}%, ${vertical}%`);
    });
    
    console.log(`Successfully added ${hotspotItems.length} hotspots to container`);
    
    // Refresh hotspot drawer if it exists
    if (typeof window.refreshHotspotDrawer === 'function') {
      window.refreshHotspotDrawer();
    }
    
    // Update hotspots visibility based on current image
    updateHotspotsVisibility();
  }
  
  // Function to update hotspots visibility based on whether current image matches original
  function updateHotspotsVisibility() {
    const hotspotsContainer = document.getElementById('bundle-product-hotspots');
    if (!hotspotsContainer) return;
    
    const mainImage = document.querySelector('.main-product-image');
    if (!mainImage || !mainImage.src) {
      hotspotsContainer.style.display = 'none';
      return;
    }
    
    const activeCard = document.querySelector('.bundle-option-card[aria-selected="true"]');
    if (!activeCard) {
      hotspotsContainer.style.display = 'none';
      return;
    }
    
    const cardId = activeCard.getAttribute('data-option-id');
    if (!cardId) {
      hotspotsContainer.style.display = 'none';
      return;
    }
    
    // Get original image URL for this card
    const originalUrl = originalMainImageUrls.get(cardId);
    if (!originalUrl) {
      // If no original URL stored yet, store current image as original and show hotspots
      const normalizedCurrent = normalizeImageUrl(mainImage.src);
      originalMainImageUrls.set(cardId, normalizedCurrent);
      hotspotsContainer.style.display = 'block';
      return;
    }
    
    // Compare current image with original
    const normalizedCurrent = normalizeImageUrl(mainImage.src);
    const normalizedOriginal = normalizeImageUrl(originalUrl);
    
    // Show hotspots only if current image matches original (first/main image)
    if (normalizedCurrent === normalizedOriginal) {
      hotspotsContainer.style.display = 'block';
    } else {
      hotspotsContainer.style.display = 'none';
    }
  }
  
  // Helper function to normalize image URLs for comparison (remove width parameters, etc.)
  function normalizeImageUrl(url) {
    if (!url) return '';
    // Remove query parameters (width, etc.) for comparison
    return url.split('?')[0].split('&')[0];
  }

  // Click handlers for cards/links
  document.querySelectorAll('.bundle-option-card, .bundle-option-card__link').forEach(el => {
    el.addEventListener('click', function(e) {
      const hasHref = this.tagName === 'A' && this.getAttribute('href');
      // Treat as tab switch; prevent navigation if present
      if (hasHref) e.preventDefault();
      const id = this.getAttribute('data-option-id') || this.closest('.bundle-option-card')?.getAttribute('data-option-id');
      if (id) {
        setActiveBundleOption(id, true);
        const cardEl = document.querySelector(`.bundle-option-card[data-option-id="${id}"]`);
        const genHero = cardEl ? cardEl.getAttribute('data-generic-bundle-image') : null;
        if (genHero) {
          updateMainImage(genHero);
        } else {
          updateMainImageFromActiveColor();
        }
        try { updateDiscountBadgesForActiveTab(); } catch(e) {}
        // Update 3rd image overlay after bundle option changes
        setTimeout(() => updateThirdImageOverlay(), 100);
      }
    });
  });

  // Activate from URL or default to first card
  function updateDiscountBadgesForActiveTab() {
    const active = document.querySelector('.bundle-option-card[aria-selected="true"]');
    if (!active) return;
    const optionId = active.getAttribute('data-option-id');
    // unified selector (one_color)
    const unified = document.querySelector(`.bundle-one-color[data-parent-id="${optionId}"]`) || document.querySelector('.bundle-one-color');
    if (unified) {
      const checkedUnified = unified.querySelector('.variant-swatch input[type="radio"]:checked');
      if (checkedUnified) {
        showDiscountAppliedForInput(checkedUnified);
        // Also show discount badges after product titles for one-color selector
        showDiscountAfterProductTitle();
      }
    }
    // two-color selectors
    document.querySelectorAll(`bundle-product[data-parent-id="${optionId}"]`).forEach(bp => {
      if (getComputedStyle(bp).display === 'none' || bp.style.display === 'none') return;
      const checked = bp.querySelector('.variant-swatch input[type="radio"]:checked');
      if (checked) showDiscountAppliedForInput(checked);
    });
  }

  // Function to set colors from URL parameters
  function setColorsFromUrl() {
    const urlParams = new URLSearchParams(window.location.search);
    const colorSelectorType = getColorSelectorType();
    
    
    if (colorSelectorType === 'one_color') {
      const unifiedColor = urlParams.get('unified_color');
      if (unifiedColor) {
        
        // First, try to find the input within the active bundle
        const activeCard = document.querySelector('.bundle-option-card[aria-selected="true"]');
        let unifiedInput = null;
        
        if (activeCard) {
          const activeId = activeCard.getAttribute('data-option-id');
          const activeBundleContainer = document.querySelector(`.bundle-one-color[data-parent-id="${activeId}"]`);
          if (activeBundleContainer) {
            unifiedInput = activeBundleContainer.querySelector(`input[name="unified-color"][value="${unifiedColor}"]`);
          }
        }
        
        // Fallback: look for any unified color input with the value
        if (!unifiedInput) {
          unifiedInput = document.querySelector(`input[name="unified-color"][value="${unifiedColor}"]`);
        }
        
        if (unifiedInput) {
          unifiedInput.checked = true;
          unifiedInput.dispatchEvent(new Event('change'));
        } else {
        }
      }
    } else {
      const topColor = urlParams.get('top_color');
      const bottomColor = urlParams.get('bottom_color');
      const thirdColor = urlParams.get('third_color');
      if (!topColor && !bottomColor && !thirdColor) return;

      __syncingBundleColors = true;
      try {
      if (topColor) {
        const activeCard = document.querySelector('.bundle-option-card[aria-selected="true"]');
        if (activeCard) {
          const activeId = activeCard.getAttribute('data-option-id');
          const topProduct = document.querySelector(`bundle-product[data-parent-id="${activeId}"][data-block-id*="-top"]`);
          if (topProduct) {
            const topColorInput = topProduct.querySelector(`input[type="radio"][value="${topColor}"]`);
            if (topColorInput) {
              topColorInput.checked = true;
              topColorInput.dispatchEvent(new Event('change'));
            }
          }
        }
      }
      
      if (bottomColor) {
        const activeCard = document.querySelector('.bundle-option-card[aria-selected="true"]');
        if (activeCard) {
          const activeId = activeCard.getAttribute('data-option-id');
          const bottomProduct = document.querySelector(`bundle-product[data-parent-id="${activeId}"][data-block-id*="-bottom"]`);
          if (bottomProduct) {
            const bottomColorInput = bottomProduct.querySelector(`input[type="radio"][value="${bottomColor}"]`);
            if (bottomColorInput) {
              bottomColorInput.checked = true;
              bottomColorInput.dispatchEvent(new Event('change'));
            }
          }
        }
      }

      if (thirdColor) {
        const activeCard = document.querySelector('.bundle-option-card[aria-selected="true"]');
        if (activeCard) {
          const activeId = activeCard.getAttribute('data-option-id');
          const thirdProduct = document.querySelector(`bundle-product[data-parent-id="${activeId}"][data-block-id*="-third"]`);
          if (thirdProduct) {
            const thirdColorInput = thirdProduct.querySelector(`input[type="radio"][value="${thirdColor}"]`);
            if (thirdColorInput) {
              thirdColorInput.checked = true;
              thirdColorInput.dispatchEvent(new Event('change'));
            }
          }
        }
      }
      } finally {
        __syncingBundleColors = false;
      }
      pinGalleryToTopProduct();
    }
  }

  (function initTabFromUrl(){
    const cards = document.querySelectorAll('.bundle-option-card');
    if (!cards.length) return;
    const urlId = new URLSearchParams(window.location.search).get('bundle');
    const firstId = cards[0].getAttribute('data-option-id');
    const targetId = urlId || firstId;
    if (targetId) setActiveBundleOption(targetId, false);
    
    // Set colors from URL parameters after bundle is set (only on initial page load)
    setTimeout(() => {
      setColorsFromUrl();
      pinGalleryToTopProduct();
    }, 100);
    
    const activeCardInit = document.querySelector('.bundle-option-card[aria-selected="true"]');
    const genHeroInit = activeCardInit ? activeCardInit.getAttribute('data-generic-bundle-image') : null;
    if (genHeroInit) {
      updateMainImage(genHeroInit);
    } else {
      updateMainImageFromActiveColor();
    }
    rebuildBundleGallery();
    try { updateDiscountBadgesForActiveTab(); } catch(e) {}
    
    // Update hotspots for initial bundle card
    const activeCard = document.querySelector('.bundle-option-card[aria-selected="true"]');
    if (activeCard) {
      const cardId = activeCard.getAttribute('data-option-id');
      if (cardId) {
        updateBundleHotspots(cardId);
      }
    }
    
    // Initialize gallery mode on page load
    const galleryEl = document.querySelector('#bundle-gallery');
    if (galleryEl) {
      const colorSelectorType = getColorSelectorType();
      if (colorSelectorType === 'one_color') {
        galleryEl.classList.add('one-color-mode');
        galleryEl.classList.remove('two-color-mode');
      } else {
        galleryEl.classList.add('two-color-mode');
        galleryEl.classList.remove('one-color-mode');
      }
    }
  })();

  // Removed global discount badge - now handled per-block

  // Removed old bundle calculation logic - now using computeBundleTotals

  // Function to format Liquid-rendered prices with commas
  function formatLiquidRenderedPrices() {
    document.querySelectorAll('.product-regular-price, .product-compare-price, .product-sale-price').forEach(el => {
      const text = el.textContent;
      if (text.includes(',')) return;
      const match = text.match(/(Rs\s*|₹\s*)?(\d{4,}(?:\.\d+)?)/);
      if (match && match[2].replace(/\.\d+/, '').length >= 4) {
        const num = parseFloat(match[2]);
        const decimals = match[2].includes('.') ? match[2].split('.')[1].length : 0;
        el.textContent = text.replace(match[0], (match[1] || '') + num.toLocaleString('en-IN', {minimumFractionDigits: decimals, maximumFractionDigits: 2}));
      }
    });
  }

  function formatMoneyRupeesFromCents(cents) {
    if (typeof cents === 'string') cents = Number.parseFloat(cents);
    if (Number.isNaN(cents) || !Number.isFinite(cents)) return '₹0';
    const rupees = Math.round(cents / 100); // 👈 round & remove decimals
    return '₹' + rupees.toLocaleString('en-IN');
  }
  
  function computeBundleTotals() {
    let originalTotalCents = 0;
    let discountedTotalCents = 0;
    const activeCard = document.querySelector('.bundle-option-card[aria-selected="true"]');
    const colorSelectorType = getColorSelectorType();

    // Handle unified color selector for one_color mode
    if (colorSelectorType === 'one_color') {
      const unifiedColorInput = document.querySelector('input[name="unified-color"]:checked');
      const selectedColorValue = unifiedColorInput ? (unifiedColorInput.value || '') : '';
      
      if (selectedColorValue && activeCard && unifiedColorInput) {
        const activeId = activeCard.getAttribute('data-option-id');
        const topProduct = document.querySelector(`bundle-product[data-parent-id="${activeId}"][data-block-id*="-top"]`);
        const bottomProduct = document.querySelector(`bundle-product[data-parent-id="${activeId}"][data-block-id*="-bottom"]`);
        const thirdProduct = document.querySelector(`bundle-product[data-parent-id="${activeId}"][data-block-id*="-third"]`);
        
        const topDiscountPercent = getColorDiscountForActiveCard(selectedColorValue, 'top');
        const bottomDiscountPercent = getColorDiscountForActiveCard(selectedColorValue, 'bottom');
        
        if (topProduct) {
          const topPriceCents = getProductPriceCents(topProduct, selectedColorValue);
          if (topPriceCents > 0) {
            const topDiscountCents = Math.round(topPriceCents * (topDiscountPercent / 100));
            originalTotalCents += topPriceCents;
            discountedTotalCents += (topPriceCents - topDiscountCents);
          }
        }
        
        if (bottomProduct) {
          const bottomPriceCents = getProductPriceCents(bottomProduct, selectedColorValue);
          if (bottomPriceCents > 0) {
            const bottomDiscountCents = Math.round(bottomPriceCents * (bottomDiscountPercent / 100));
            originalTotalCents += bottomPriceCents;
            discountedTotalCents += (bottomPriceCents - bottomDiscountCents);
          }
        }

        if (thirdProduct) {
          const thirdPriceCents = getProductPriceCents(thirdProduct, selectedColorValue);
          if (thirdPriceCents > 0) {
            originalTotalCents += thirdPriceCents;
            discountedTotalCents += thirdPriceCents;
          }
        }
      }
    } else {
      // Original logic for two_color mode
      productContainers.forEach(productContainer => {
        const isVisible = productContainer.style.display !== 'none' &&
                          !productContainer.classList.contains('hidden') &&
                          getComputedStyle(productContainer).display !== 'none';
        if (!isVisible) return;

        let priceCents = 0;
        // Always detect selected color first (for discount application), regardless of size selection
        const colorInput = productContainer.querySelector('input[type="radio"]:checked');
        const selectedColorValue = colorInput ? (colorInput.value || '') : '';

        // Determine price: prefer selected size button price, else selected color price, else fallback via variant id lookup
        const sizeBtn = productContainer.querySelector('.product-variant-size-button.selected');
        if (sizeBtn && sizeBtn.getAttribute('data-price')) {
          priceCents = Number.parseFloat(sizeBtn.getAttribute('data-price')) || 0;
        }
        if (!priceCents && colorInput && colorInput.getAttribute('data-price')) {
          priceCents = Number.parseFloat(colorInput.getAttribute('data-price')) || 0;
        }
        if (!priceCents) {
          const hiddenId = productContainer.querySelector('.product-variant-id');
          if (hiddenId) {
            const anyBtn = productContainer.querySelector(`.product-variant-size-button[data-variant-id="${hiddenId.value}"]`);
            if (anyBtn && anyBtn.getAttribute('data-price')) {
              priceCents = Number.parseFloat(anyBtn.getAttribute('data-price')) || 0;
            }
          }
        }
 
        let side = getBundleProductSide(productContainer, activeCard);

        // Per-color percent from active card
        const appliedPercent = selectedColorValue ? getColorDiscountForActiveCard(selectedColorValue, side) : 0;
        const itemDiscountCents = Math.round(priceCents * (appliedPercent / 100));

        originalTotalCents += priceCents;
        discountedTotalCents += (priceCents - itemDiscountCents);
      });
    }

    // Apply bundle discount to the entire bundle (on original total)
    if (activeCard && originalTotalCents > 0) {
      const bundleDiscountPercent = parseFloat(activeCard.getAttribute('data-discount-percent') || '0');
      if (bundleDiscountPercent > 0) {
        // Apply bundle discount to the original bundle total
        const bundleDiscountCents = Math.round(originalTotalCents * (bundleDiscountPercent / 100));
        // Subtract bundle discount from the already-discounted total
        discountedTotalCents = discountedTotalCents - bundleDiscountCents;
        // Ensure discounted total doesn't go below zero
        if (discountedTotalCents < 0) discountedTotalCents = 0;
      }
    }

    // Update UI with totals
    if (originalTotalEl) {
      console.log('Bundle Totals:', { originalTotalCents, discountedTotalCents });
      if (originalTotalCents > discountedTotalCents) {
        originalTotalEl.textContent = formatMoneyRupeesFromCents(originalTotalCents);
        originalTotalEl.style.display = 'inline';
      } else {
        originalTotalEl.textContent = '';
        originalTotalEl.style.display = 'none';
      }
    }
    if (discountedTotalEl) {
      discountedTotalEl.textContent = formatMoneyRupeesFromCents(discountedTotalCents);
    }

    // one_color (women bundle): show the "Total / compare / save" strip.
    // Liquid/CSS hides `#bundle-totals` by default; we enable it only when relevant.
    {
      const forms = Array.from(document.querySelectorAll('form#bundle-form'));
      const form = forms.find(f => f && f.offsetParent !== null) || forms[0];
      const totals = form ? form.querySelector('#bundle-totals') : null;
      if (totals) {
        const shouldShowTotals = (colorSelectorType === 'one_color' && discountedTotalCents > 0);
        totals.style.display = shouldShowTotals ? 'block' : 'none';
      }
    }
    
    // Dispatch event for hotspot drawer to update price
    document.dispatchEvent(new CustomEvent('bundleTotalsUpdated'));

    // Update savings badge (for hidden totals)
    const savingsCents = Math.max(0, originalTotalCents - discountedTotalCents);
    if (discountBadgeEl) {
      if (savingsCents > 0) {
        discountBadgeEl.textContent = `(Save ${formatMoneyRupeesFromCents(savingsCents)})`;
        discountBadgeEl.style.display = 'inline';
      } else {
        discountBadgeEl.textContent = '';
        discountBadgeEl.style.display = 'none';
      }
    }
    
    // Update the selected bundle header (red-highlight summary area)
    const headerPriceEl = document.getElementById('bundle-selected-summary-price');
    const headerCompareEl = document.getElementById('bundle-selected-summary-compare');
    const headerSaveEl = document.getElementById('bundle-selected-summary-save');
    if (headerPriceEl) {
      headerPriceEl.textContent = formatMoneyRupeesFromCents(discountedTotalCents);
    }
    if (headerCompareEl) {
      if (originalTotalCents > discountedTotalCents) {
        headerCompareEl.textContent = formatMoneyRupeesFromCents(originalTotalCents);
        headerCompareEl.style.display = 'inline';
      } else {
        headerCompareEl.textContent = '';
        headerCompareEl.style.display = 'none';
      }
    }
    if (headerSaveEl) {
      if (savingsCents > 0) {
        headerSaveEl.textContent = `SAVE ${formatMoneyRupeesFromCents(savingsCents)}`;
        headerSaveEl.style.display = 'block';
      } else {
        headerSaveEl.textContent = '';
        headerSaveEl.style.display = 'none';
      }
    }

    // one_color selector: change bundle button heading text
    {
      const forms = Array.from(document.querySelectorAll('form#bundle-form'));
      const form = forms.find(f => f && f.offsetParent !== null) || forms[0];
      const buttonTextEl = form ? form.querySelector('#bundle-button-text') : null;
      // if (buttonTextEl) {
      //   buttonTextEl.textContent = (colorSelectorType === 'one_color') ? 'Add To Bag' : 'Add To Bag';
      // }
    }
    // Update button with price (handle both forms if they exist)
    const buttonPriceEl = document.getElementById('bundle-button-price');
    const buttonPriceValueEl = document.getElementById('bundle-button-price-value');
    // Both one_color and two_color: show price in button when discounted (Figma design)
    if (buttonPriceEl && buttonPriceValueEl && discountedTotalCents > 0) {
      buttonPriceValueEl.textContent = formatMoneyRupeesFromCents(discountedTotalCents);
      buttonPriceEl.style.display = 'inline';
    } else if (buttonPriceEl) {
      buttonPriceEl.style.display = 'none';
    }
    
    // Update savings display below button (both one_color and two_color - Figma design)
    const savingsDisplayEl = document.getElementById('bundle-savings-display');
    const savingsTextEl = document.getElementById('bundle-savings-text');
    if (savingsDisplayEl && savingsTextEl) {
      if (savingsCents > 0) {
        savingsTextEl.textContent = `SAVE ${formatMoneyRupeesFromCents(savingsCents)}`;
        savingsDisplayEl.style.display = 'flex';
      } else {
        savingsDisplayEl.style.display = 'none';
      }
    }

    // Update mobile sticky add-to-cart (if present)
    document.querySelectorAll('[data-bundle-sticky-atc]').forEach((bar) => {
      const tagline = bar.querySelector('[data-bundle-sticky-tagline]');
      const buttonPrice = bar.querySelector('[data-bundle-sticky-price]');
      const meta = bar.querySelector('[data-bundle-sticky-meta]');
      const compare = bar.querySelector('[data-bundle-sticky-compare]');
      const priceInline = bar.querySelector('[data-bundle-sticky-price-inline]');
      const save = bar.querySelector('[data-bundle-sticky-save]');

      if (buttonPrice) buttonPrice.textContent = formatMoneyRupeesFromCents(discountedTotalCents);

      // Red-highlight line (top of sticky): "Add 2 sets and save X%"
      if (tagline) {
        // Pull from the section setting "Discount Banner Text" (same text shown above the in-section button).
        // We read it from DOM so we don't hardcode or duplicate the setting in JS.
        const forms = Array.from(document.querySelectorAll('form#bundle-form'));
        const form = forms.find(f => f && f.offsetParent !== null) || forms[0];
        const bannerTextEl = form ? form.querySelector('.bundle-discount-banner__text') : null;
        const bannerText = bannerTextEl ? (bannerTextEl.textContent || '').trim() : '';

        if (bannerText) {
          tagline.textContent = bannerText;
          tagline.style.display = 'flex';
        } else {
          // Fallback: if banner is disabled/empty, hide tagline.
          tagline.textContent = '';
          tagline.style.display = 'none';
        }
      }

      if (meta && compare && priceInline && save) {
        if (savingsCents > 0) {
          compare.textContent = formatMoneyRupeesFromCents(originalTotalCents);
          priceInline.textContent = formatMoneyRupeesFromCents(discountedTotalCents);
          save.textContent = `SAVE ${formatMoneyRupeesFromCents(savingsCents)}`;
          meta.style.display = 'flex';
        } else {
          meta.style.display = 'none';
        }
      }
    });
  }

  // Batch recalculations to avoid redundant work on rapid UI changes
  function scheduleTotalsCompute() {
    if (totalsRaf != null) return;
    totalsRaf = requestAnimationFrame(() => {
      totalsRaf = null;
      computeBundleTotals();
    });
  }

  // Helper function to get product price in cents for unified color selector
  function getProductPriceCents(productContainer, selectedColorValue) {
    if (!productContainer || !selectedColorValue) return 0;
    
    let priceCents = 0;
    
    // Try to find a color input with the selected color value
    const colorInput = productContainer.querySelector(`input[type="radio"][value="${selectedColorValue}"]`);
    
    // Determine price: prefer selected size button price, else selected color price, else fallback via variant id lookup
    const sizeBtn = productContainer.querySelector('.product-variant-size-button.selected');
    if (sizeBtn && sizeBtn.getAttribute('data-price')) {
      priceCents = Number.parseFloat(sizeBtn.getAttribute('data-price')) || 0;
    }
    if (!priceCents && colorInput && colorInput.getAttribute('data-price')) {
      priceCents = Number.parseFloat(colorInput.getAttribute('data-price')) || 0;
    }
    if (!priceCents) {
      const hiddenId = productContainer.querySelector('.product-variant-id');
      if (hiddenId) {
        const anyBtn = productContainer.querySelector(`.product-variant-size-button[data-variant-id="${hiddenId.value}"]`);
        if (anyBtn && anyBtn.getAttribute('data-price')) {
          priceCents = Number.parseFloat(anyBtn.getAttribute('data-price')) || 0;
        }
      }
    }
    
    return priceCents;
  }

  // Utility: Read color discount from active option card by color key and product side
  function getColorDiscountForActiveCard(colorValue, side /* 'top' | 'bottom' | 'third' */) {
    if (side === 'third') return 0;
    const activeCard = document.querySelector('.bundle-option-card[aria-selected="true"]');
    if (!activeCard || !colorValue) {
      console.log('getColorDiscountForActiveCard: No active card or color value');
      return 0;
    }
    const key = (colorValue + '').toLowerCase().replace(/\s+/g, '_');
    const attr = side === 'bottom' ? `data-bottom-color-${key}` : `data-top-color-${key}`;
    const raw = activeCard.getAttribute(attr);
    const num = Number.parseFloat(raw || '');
    
    console.log('getColorDiscountForActiveCard:', {
      colorValue,
      side,
      key,
      attr,
      raw,
      num,
      activeCard: activeCard.getAttribute('data-option-id')
    });
    
    return Number.isFinite(num) ? num : 0;
  }

  // UI: Show discount badge after product title for one-color selector
  function showDiscountAfterProductTitle() {
    const colorSelectorType = getColorSelectorType();
    console.log('showDiscountAfterProductTitle called, colorSelectorType:', colorSelectorType);
    
    if (colorSelectorType !== 'one_color') {
      console.log('Not one_color mode, returning');
      return;
    }
    
    const unifiedColorInput = document.querySelector('input[name="unified-color"]:checked');
    console.log('unifiedColorInput:', unifiedColorInput);
    if (!unifiedColorInput) {
      console.log('No unified color input found');
      return;
    }
    
    const selectedColorValue = unifiedColorInput.value;
    console.log('selectedColorValue:', selectedColorValue);
    
    const activeCard = document.querySelector('.bundle-option-card[aria-selected="true"]');
    console.log('activeCard:', activeCard);
    if (!activeCard) {
      console.log('No active card found');
      return;
    }
    
    // Get discount percentages for both top and bottom
    const topDiscountPercent = getColorDiscountForActiveCard(selectedColorValue, 'top');
    const bottomDiscountPercent = getColorDiscountForActiveCard(selectedColorValue, 'bottom');
    console.log('Discount percentages:', { topDiscountPercent, bottomDiscountPercent });
    
    // Find all price containers in the current active bundle
    const activeId = activeCard.getAttribute('data-option-id');
    const priceContainers = document.querySelectorAll(`bundle-product[data-parent-id="${activeId}"] .product-description`);
    console.log('Found price containers:', priceContainers.length);
    
    priceContainers.forEach((priceContainer, index) => {
      console.log(`Processing price container ${index}:`, priceContainer);
      
      // Determine if this is top or bottom product
      const productContainer = priceContainer.closest('bundle-product');
      const side = getBundleProductSide(productContainer, activeCard);
      const isBottomProduct = side === 'bottom';
      const discountPercent = getColorDiscountForActiveCard(selectedColorValue, side);
      console.log(`Product ${index} discount:`, discountPercent);
      
      // Remove existing discount badge
      const existingBadge = priceContainer.querySelector('.price-discount-badge');
      if (existingBadge) {
        console.log('Removing existing badge');
        existingBadge.remove();
      }
      
      // Add new discount badge if there's a discount
      if (discountPercent > 0) {
        console.log(`Adding discount badge for product ${index}: ${discountPercent}%`);
        const badge = document.createElement('div');
        badge.className = 'price-discount-badge';
        badge.style.color = '#0066cc';
        badge.style.fontWeight = '600';
        badge.textContent = `[ ${discountPercent}% Off ]`;
        badge.title = `${isBottomProduct ? 'Bottom' : 'Top'} Product - ${discountPercent}% Discount`;
        priceContainer.appendChild(badge);
        console.log('Badge added:', badge);
      } else {
        console.log(`No discount for product ${index}`);
      }
    });
  }

  // UI: Show "[Discount Applied]" next to selected color labels
  // Function to add SALE badges to color swatches with discounts
  function updateSaleBadgesOnColorSwatches() {
    const activeCard = document.querySelector('.bundle-option-card[aria-selected="true"]');
    if (!activeCard) return;

    const colorSelectorType = getColorSelectorType();
    
    // Get all color swatches
    const allSwatches = document.querySelectorAll('.variant-swatch');
    
    allSwatches.forEach(swatch => {
      const input = swatch.querySelector('input[type="radio"]');
      if (!input) return;
      
      const colorValue = input.value;
      if (!colorValue) return;
      
      const swatchColor = swatch.querySelector('.variant-swatch__color');
      if (!swatchColor) return;
      
      // Remove existing has-discount class
      swatchColor.classList.remove('has-discount');
      
      // Determine side (top/bottom) for discount lookup
      let side = 'top';
      const isUnified = input.name === 'unified-color';
      
      if (!isUnified) {
        const container = input.closest('bundle-product');
        if (container) {
          side = getBundleProductSide(container, activeCard);
        }
      } else {
        // For unified color selector, check both top and bottom
        // If either has discount, show the badge
        const topDiscount = getColorDiscountForActiveCard(colorValue, 'top');
        const bottomDiscount = getColorDiscountForActiveCard(colorValue, 'bottom');
        if (topDiscount > 0 || bottomDiscount > 0) {
          swatchColor.classList.add('has-discount');
        }
        return;
      }
      
      // Check if this color has a discount
      const discountPercent = getColorDiscountForActiveCard(colorValue, side);
      if (discountPercent > 0) {
        swatchColor.classList.add('has-discount');
      }
    });
  }

  function showDiscountAppliedForInput(inputEl) {
    if (!inputEl) return;
    
    // Hide discount badges in one-color selector mode
    const colorSelectorType = getColorSelectorType();
    if (colorSelectorType === 'one_color') {
      return;
    }
    
    const value = inputEl.value;
    // Detect side: unified-one-color is outside products
    let side = 'top';
    const isUnified = inputEl.name === 'unified-color';
    if (!isUnified) {
      const container = inputEl.closest('bundle-product');
      if (container) {
        side = getBundleProductSide(container, document.querySelector('.bundle-option-card[aria-selected="true"]'));
      }
    }

    const discountPercent = getColorDiscountForActiveCard(value, side);

    // Find the nearest label .color_name
    let labelEl = null;
    if (isUnified) {
      const wrapper = inputEl.closest('.bundle-one-color');
      labelEl = wrapper ? wrapper.querySelector('h4 .color_name') : null;
    } else {
      const legend = inputEl.closest('fieldset')?.querySelector('legend .color_name');
      labelEl = legend || null;
    }
    if (!labelEl) return;
    if (value) labelEl.textContent = value;

    const existing = labelEl.parentElement.querySelector('.discount-applied-badge');
    if (existing) existing.remove();
    if (discountPercent > 0) {
      const badge = document.createElement('span');
      badge.className = 'discount-applied-badge';
      badge.style.marginLeft = '6px';
      badge.style.color = '#0066cc';
      badge.style.fontWeight = '600';
      badge.textContent = `[ ${discountPercent}% Off ]`;
      badge.setAttribute('data-debug', `color:${(value||'').toString()};side:${side};discount:${discountPercent}`);
      badge.title = `Color:${value} • Side:${side} • Discount:${discountPercent}%`;
      labelEl.after(badge);
    }
  }

  function ensureColorSelected(productContainer) {
    if (!productContainer) return;
    if (productContainer.querySelector('input[type="radio"]:checked')) return;

    // Check if there are URL color parameters - if so, don't auto-select colors
    const urlParams = new URLSearchParams(window.location.search);
    const hasUrlColors = urlParams.get('unified_color') || urlParams.get('top_color') || urlParams.get('bottom_color') || urlParams.get('third_color');
    if (hasUrlColors) {
      return;
    }

    const inputs = productContainer.querySelectorAll('.variant-swatch input[type="radio"]');
    let candidate = null;
    for (let i = 0; i < inputs.length; i++) {
      const swatch = inputs[i].closest('.variant-swatch');
      if (swatch && getComputedStyle(swatch).display !== 'none') { candidate = inputs[i]; break; }
    }
    if (!candidate) candidate = productContainer.querySelector('input[type="radio"]');
    if (!candidate) return;

    candidate.checked = true;
    candidate.dispatchEvent(new Event('change', { bubbles: true }));
  }

  function ensureActiveTabSelections() {
    const activeCard = document.querySelector('.bundle-option-card[aria-selected="true"]');
    let products = null;
    if (activeCard) {
      const optionId = activeCard.getAttribute('data-option-id');
      products = document.querySelectorAll(`bundle-product[data-parent-id="${optionId}"]`);
    }
    if (!products || !products.length) {
      products = document.querySelectorAll('bundle-product');
    }
    products.forEach((bp) => {
      const display = getComputedStyle(bp).display;
      if (display !== 'none' && bp.style.display !== 'none') ensureColorSelected(bp);
    });
  }

  // Ensure the first visible color swatch is selected for the active tab
  function selectFirstColorForActiveTab() {
    const colorSelectorType = getColorSelectorType();
    const activeCard = document.querySelector('.bundle-option-card[aria-selected="true"]');
    let optionId = null;
    if (activeCard) optionId = activeCard.getAttribute('data-option-id');

    // Check if there are URL color parameters first
    const urlParams = new URLSearchParams(window.location.search);
    const hasUrlColors = urlParams.get('unified_color') || urlParams.get('top_color') || urlParams.get('bottom_color') || urlParams.get('third_color');
    
    // If URL has color parameters, don't override them - let setColorsFromUrl handle it
    if (hasUrlColors) {
      return;
    }

    if (colorSelectorType === 'one_color') {
      // Unified color selector lives outside bundle-product
      let container = null;
      if (optionId) {
        container = document.querySelector(`.bundle-one-color[data-parent-id="${optionId}"]`);
      }
      if (!container) {
        container = document.querySelector('.bundle-one-color');
      }
      if (container) {
        const inputs = Array.from(container.querySelectorAll('.variant-swatch input[type="radio"]'));
        const firstVisible = inputs.find((inp) => {
          const swatch = inp.closest('.variant-swatch');
          return swatch && getComputedStyle(swatch).display !== 'none';
        }) || inputs[0];
        if (firstVisible) {
          firstVisible.checked = true;
          const colorNameEl = container.querySelector('.color_name');
          if (colorNameEl) colorNameEl.textContent = firstVisible.value;
          firstVisible.dispatchEvent(new Event('change', { bubbles: true }));
        }
        try { 
          showDiscountAppliedForInput(container.querySelector('.variant-swatch input[type="radio"]:checked')); 
          showDiscountAfterProductTitle();
        } catch(e) {}
      }
    } else {
      // Two color selectors live inside each visible bundle-product
      const selector = optionId ? `bundle-product[data-parent-id="${optionId}"]` : 'bundle-product';
      document.querySelectorAll(selector).forEach((bp) => {
        if (getComputedStyle(bp).display === 'none' || bp.style.display === 'none') return;
        const inputs = Array.from(bp.querySelectorAll('.variant-swatch input[type="radio"]'));
        const firstVisible = inputs.find((inp) => {
          const swatch = inp.closest('.variant-swatch');
          return swatch && getComputedStyle(swatch).display !== 'none';
        }) || inputs[0];
        if (firstVisible) {
          firstVisible.checked = true;
          const colorNameEl = bp.querySelector('.color_name');
          if (colorNameEl) colorNameEl.textContent = firstVisible.value;
          firstVisible.dispatchEvent(new Event('change', { bubbles: true }));
        }
        try { showDiscountAppliedForInput(bp.querySelector('.variant-swatch input[type="radio"]:checked')); } catch(e) {}
      });
    }
  }

  function syncActiveTabColorAndSizes() {
    if (getColorSelectorType() !== 'two_color') return;

    const activeCard = document.querySelector('.bundle-option-card[aria-selected="true"]');
    if (!activeCard) return;
    const optionId = activeCard.getAttribute('data-option-id');

    __syncingBundleColors = true;
    try {
    document.querySelectorAll(`bundle-product[data-parent-id="${optionId}"]`).forEach((bp) => {
      if (getComputedStyle(bp).display === 'none' || bp.style.display === 'none') return;

      const inputs = Array.from(bp.querySelectorAll('.variant-swatch input[type="radio"]'));
      const firstVisible = inputs.find((inp) => {
        const swatch = inp.closest('.variant-swatch');
        return swatch && getComputedStyle(swatch).display !== 'none';
      }) || inputs[0];

      const blockId = bp.getAttribute('data-block-id') || '';
      const urlParams = new URLSearchParams(window.location.search);
      const urlColor = blockId.includes('-third')
        ? urlParams.get('third_color')
        : blockId.includes('-bottom')
          ? urlParams.get('bottom_color')
          : blockId.includes('-top')
            ? urlParams.get('top_color')
            : null;

      let checked = urlColor
        ? (inputs.find((inp) => inp.value === urlColor) || null)
        : firstVisible;

      if (!checked) checked = firstVisible;
      if (!checked) return;

      checked.checked = true;

      const colorNameEl = bp.querySelector('.color_name');
      if (colorNameEl) colorNameEl.textContent = checked.value;

      const productHandle = checked.getAttribute('data-product-handle') || bp.getAttribute('data-product-handle');
      if (productHandle) {
        sizeSwatchFetch(checked.value, productHandle, bp);
      }

      checked.dispatchEvent(new Event('change', { bubbles: true }));

      setTimeout(() => {
        updateVariantId(bp);
        try { showDiscountAppliedForInput(checked); } catch (e) {}
      }, 100);
    });
    } finally {
      __syncingBundleColors = false;
    }

    const topHandle = activeCard.getAttribute('data-top-handle');
    if (topHandle) {
      __lastGalleryProductHandle = topHandle;
      window.__lastInteractedProductHandle = topHandle;
    }
    pinGalleryToTopProduct();

    scheduleTotalsCompute();
  }

  // Update the main image using the first visible/selected swatch image of the active tab
  function updateMainImageFromActiveColor() {
    const mainImage = document.querySelector('.main-product-image');
    if (!mainImage) return;

    const genericHero = genericBundleHeroUrl();
    if (genericHero) {
      updateMainImage(genericHero);
      return;
    }

    const colorSelectorType = getColorSelectorType();
    const activeCard = document.querySelector('.bundle-option-card[aria-selected="true"]');
    let optionId = activeCard ? activeCard.getAttribute('data-option-id') : null;

    // Helper to get image URL from an input swatch element
    const getImageFromInput = (inputEl) => {
      if (!inputEl) return null;
      // Priority: data-image (metafield large image mapping), then span's data-variant-image, then input's data-image-url
      const swatch = inputEl.closest('.variant-swatch');
      const span = swatch ? swatch.querySelector('.variant-swatch__color') : null;
      const imgA = inputEl.getAttribute('data-image');
      const imgB = span ? span.getAttribute('data-variant-image') : null;
      const imgC = inputEl.getAttribute('data-image-url');
      return imgA || imgB || imgC || null;
    };

    // Helper: try to get bottom product image for a given color in one_color mode
    const getBottomProductImageForColor = (optionIdLocal, colorValue) => {
      if (!optionIdLocal || !colorValue) return null;
      const active = document.querySelector(`.bundle-option-card[aria-selected="true"][data-option-id="${optionIdLocal}"]`);
      const bottomHandle = active ? active.getAttribute('data-bottom-handle') : null;
      if (!bottomHandle) return null;
      const bp = document.querySelector(`bundle-product[data-parent-id="${optionIdLocal}"][data-product-handle="${bottomHandle}"]`);
      if (!bp) return null;
      const inputs = Array.from(bp.querySelectorAll('.variant-swatch input[type="radio"]'));
      const match = inputs.find(i => i.value === colorValue);
      return getImageFromInput(match || null);
    };

    // Try unified one_color container first if applicable
    if (colorSelectorType === 'one_color') {
      let container = optionId
        ? document.querySelector(`.bundle-one-color[data-parent-id="${optionId}"]`)
        : null;
      if (!container) container = document.querySelector('.bundle-one-color');
      if (container) {
        const inputs = Array.from(container.querySelectorAll('.variant-swatch input[type="radio"]'));
        const selected = inputs.find(i => i.checked);
        const firstVisible = inputs.find((inp) => {
          const sw = inp.closest('.variant-swatch');
          return sw && getComputedStyle(sw).display !== 'none';
        }) || inputs[0];
        const chosen = selected || firstVisible;
        const colorVal = chosen ? chosen.value : null;
        // Use unified input's image first (from large_variant_image) - ensures images show on auto-select
        const url = getImageFromInput(chosen);
        const bottomUrl = getBottomProductImageForColor(optionId, colorVal);
        const imageToUse = url || bottomUrl;
        if (imageToUse) {
          updateMainImage(imageToUse);
        }
        try { showDiscountAppliedForInput(chosen); } catch(e) {}
        return;
      }
    }

    // Fallback / two_color: prefer the top product image (bottom only after user selects it)
    const selector = optionId ? `bundle-product[data-parent-id="${optionId}"]` : 'bundle-product';
    const visibleProducts = Array.from(document.querySelectorAll(selector)).filter(bp => getComputedStyle(bp).display !== 'none' && bp.style.display !== 'none');
    const topHandle = activeCard ? activeCard.getAttribute('data-top-handle') : null;
    const topProduct = visibleProducts.find((bp) => {
      const handle = bp.getAttribute('data-product-handle');
      const blockId = bp.getAttribute('data-block-id') || '';
      return (topHandle && handle === topHandle) || /-top$/.test(blockId);
    });
    const orderedProducts = topProduct
      ? [topProduct, ...visibleProducts.filter((bp) => bp !== topProduct)]
      : visibleProducts;
    for (const bp of orderedProducts) {
      const inputs = Array.from(bp.querySelectorAll('.variant-swatch input[type="radio"]'));
      const selected = inputs.find(i => i.checked);
      const firstVisible = inputs.find((inp) => {
        const sw = inp.closest('.variant-swatch');
        return sw && getComputedStyle(sw).display !== 'none';
      }) || inputs[0];
      const chosen = selected || firstVisible;
      const url = getImageFromInput(chosen);
      if (url) {
        updateMainImage(url);
        try { showDiscountAppliedForInput(chosen); } catch(e) {}
        return;
      }
    }
  }

  // Build thumbnail gallery from active products and current color selection
  function rebuildBundleGallery() {
    const galleryEl = document.querySelector('#bundle-gallery');
    const thumbsWrap = document.querySelector('#bundle-gallery .bundle-thumbs');
    if (!thumbsWrap || !galleryEl) return;
    thumbsWrap.innerHTML = '';

    // 3rd image overlay 
    updateThirdImageOverlay();

    const colorSelectorType = getColorSelectorType();
    
    // Update gallery class based on selector type
    if (colorSelectorType === 'one_color') {
      galleryEl.classList.add('one-color-mode');
      galleryEl.classList.remove('two-color-mode');
    } else {
      galleryEl.classList.add('two-color-mode');
      galleryEl.classList.remove('one-color-mode');
    }
    
    const activeCard = document.querySelector('.bundle-option-card[aria-selected="true"]');
    const optionId = activeCard ? activeCard.getAttribute('data-option-id') : null;
    
    // Get the current active bundle from data-bundle-option-card attribute
    const currentBundle = activeCard ? activeCard.getAttribute('data-bundle-option-card') : null;

    // Determine which product's gallery to show and then derive selectedColor from THAT product
    let selectedColor = null;
    let targetHandle = __lastGalleryProductHandle;
    const active = document.querySelector('.bundle-option-card[aria-selected="true"]');
    const activeId = active ? active.getAttribute('data-option-id') : optionId;

    // If no explicit last-handle, try to infer from checked swatch within the active card
    if (!targetHandle && activeId) {
      const checkedSwatch = document.querySelector(`bundle-product[data-parent-id="${activeId}"] .variant-swatch input[type="radio"]:checked`);
      if (checkedSwatch) {
        targetHandle = checkedSwatch.getAttribute('data-product-handle') || checkedSwatch.closest('bundle-product')?.getAttribute('data-product-handle') || null;
      }
    } 

    // Fallback: first product within the active card
    if (!targetHandle && activeId) {
      const firstProduct = document.querySelector(`bundle-product[data-parent-id="${activeId}"]`);
      targetHandle = firstProduct ? firstProduct.getAttribute('data-product-handle') : null;
    }

    // Now compute selectedColor depending on selector type
    if (colorSelectorType === 'one_color') {
      let container = activeId
        ? document.querySelector(`.bundle-one-color[data-parent-id="${activeId}"]`)
        : null;
      if (!container) container = document.querySelector('.bundle-one-color');
      if (container) {
        const checked = container.querySelector('.variant-swatch input[type="radio"]:checked');
        selectedColor = checked ? (checked.value || '').toLowerCase() : null;
      }
    } else if (activeId && targetHandle) {
      const productNode = document.querySelector(`bundle-product[data-parent-id="${activeId}"][data-product-handle="${targetHandle}"]`);
      if (productNode) {
        const checked = productNode.querySelector('.variant-swatch input[type="radio"]:checked');
        selectedColor = checked ? (checked.value || '').toLowerCase() : null;
      }
    }

    // Collect images from product(s)
    const images = [];
    const productJson = document.querySelector('#block-products-json');
    try {
      const all = productJson ? JSON.parse(productJson.textContent || '{}') : {};
      if (colorSelectorType === 'one_color') {
        // In one_color mode, show thumbnails for BOTH products of the active bundle option
        const activeCardNode = document.querySelector('.bundle-option-card[aria-selected="true"]');
        const topHandle = activeCardNode ? activeCardNode.getAttribute('data-top-handle') : null;
        const bottomHandle = activeCardNode ? activeCardNode.getAttribute('data-bottom-handle') : null;
        const thirdHandle = activeCardNode ? activeCardNode.getAttribute('data-third-handle') : null;
        const handles = [topHandle, bottomHandle, thirdHandle].filter(Boolean);
        handles.forEach(h => {
          const p = all[h];
          if (p && Array.isArray(p.media)) {
            p.media.forEach(img => {
              let url = '';
              let alt = '';
              
              if (typeof img === 'string') { 
                url = img;
                alt = '';
              } else if (img) {
                url = img.src || img.url || '';
                alt = (img.alt || '').toLowerCase();
              }
              if (!url) return;
              if ((alt || '').includes('#3set')) return;
              images.push({ url, alt });
            });
          }
        });
      } else if (targetHandle) {
        const p = all[targetHandle];
        if (p && Array.isArray(p.media)) {
          p.media.forEach(img => {
            let url = '';
            let alt = '';
            if (typeof img === 'string') {
              url = img;
              alt = '';
            } else if (img) {
              url = img.src || img.url || '';
              alt = (img.alt || '').toLowerCase();
            }
            if (!url) return;
            images.push({ url, alt });
          });
        }
      }
    } catch (e) {}

    // Filter by selected color if matches exist (robust match: plain, handleized, hashtag tokens)
    let filtered = images;
    if (selectedColor) {
      const colorLower = selectedColor.toLowerCase();
      const colorHandle = colorLower.replace(/\s+/g,'-').replace(/[^a-z0-9-]/g,'');
      const colorTight = colorLower.replace(/\s+/g,'');
        const colorOriginalHandle = `#colour_${selectedColor.replace(/\s+/g, '_').replace(/[^a-zA-Z0-9-_]/g, '')}`; // Keep as #colour_Forest_Green
        const colorOriginalHandle2 = `#color_${selectedColor.replace(/\s+/g, '_').replace(/[^a-zA-Z0-9-_]/g, '')}`; // Keep as #colour_Forest_Green

    // debug info moved to badge attributes

      const matches = images.filter(i => {
        const alt = (i.alt || '').toLowerCase();
        if (!alt) return false;
        return (
          alt.includes(colorLower) || 
          alt.includes(colorHandle) ||
          alt.includes(colorTight) ||
          alt.includes(`#color_${colorHandle}`) ||
          alt.includes(`#colour_${colorHandle}`) ||
          alt.includes(`#${colorHandle}`) ||
           alt.includes(colorOriginalHandle2) || 
           alt.includes(colorOriginalHandle) 

        );
      });
      // If color matches found, use them; otherwise show all images
      if (matches.length) filtered = matches;
    }

    // Filter by bundle - exclude images that contain other bundle names in alt text
    if (currentBundle) {
      filtered = filtered.filter(img => {
        const alt = (img.alt || '').toLowerCase();
        if (!alt) return true; // Keep images without alt text
        const allow3Set = activeCard && activeCard.getAttribute('data-3set-hero') === 'true';
        if (alt.includes('#3set') && !allow3Set) return false;
        
        // Extract the bundle type from the current bundle name (everything after the last underscore)
        const currentBundleType = currentBundle.split('_').pop();
        
        // Create variations for the bundle type
        const bundleTypeVariations = [
          currentBundleType,
          currentBundleType.replace(/_/g, ' '),
          currentBundleType.replace(/_/g, '-'),
          currentBundleType.replace(/_/g, '')
        ];
        
        console.log('Filtering image alt for bundle', {
          alt: alt,
          currentBundle: currentBundle,
          currentBundleType: currentBundleType,
          variations: bundleTypeVariations
        }); 
        
        // Check if alt contains current bundle type (keep these)
        const containsCurrentBundleType = bundleTypeVariations.some(variation => 
          alt.includes(variation.toLowerCase())
        );
        // Check if alt contains other bundle types (exclude these)
        // top_short/top_pyjama/half_tee_short: use specific tags - exclude wrong bundle images
        let otherBundleTypes = [];
        if (currentBundleType === 'pyjamas' || currentBundleType === 'pyjama') {
          otherBundleTypes = ['top_short', '#top_short'];
        } else if (currentBundleType === 'shorts' || currentBundleType === 'short') {
          otherBundleTypes = ['top_pyjama', '#top_pyjama'];
        }
        if (currentBundle) {
          const bundleLower = currentBundle.toLowerCase();
          if (bundleLower.includes('oversized')) {
            if (bundleLower.includes('shorts') || bundleLower.includes('short')) {
              otherBundleTypes = otherBundleTypes.concat(['half_tee_short', '#half_tee_short']);
            } else if (bundleLower.includes('pyjama')) {
              otherBundleTypes = otherBundleTypes.concat(['half_tee_pyjama', '#half_tee_pyjama']);
            }
          }
        }
        
        const containsOtherBundleType = otherBundleTypes.some(bundleType => {
          return alt.includes(bundleType.toLowerCase());
        });
        
        console.log('Bundle filtering debug:', {
          alt: alt,
          currentBundleType: currentBundleType,
          containsCurrentBundleType: containsCurrentBundleType,
          containsOtherBundleType: containsOtherBundleType,
          result: containsCurrentBundleType || !containsOtherBundleType
        });
        
        // Keep if it contains current bundle type OR doesn't contain any bundle-specific text
        return containsCurrentBundleType || !containsOtherBundleType;
      });

      // When this bundle has its own tagged photos, show those before shared colour photos.
      if (colorSelectorType === 'one_color' && !String(currentBundle).includes('oversized')) {
        const bundleType = String(currentBundle).split('_').pop();
        const bundleTag = (bundleType === 'pyjamas' || bundleType === 'pyjama')
          ? 'top_pyjama'
          : ((bundleType === 'shorts' || bundleType === 'short') ? 'top_short' : '');
        if (bundleTag) {
          const tagged = filtered.filter((img) => (img.alt || '').includes(bundleTag));
          if (tagged.length) {
            const rest = filtered.filter((img) => !(img.alt || '').includes(bundleTag));
            filtered = tagged.concat(rest);
          }
        }
      }
    }

    // De-dupe by URL and cap to 24
    const seen = new Set();
    const unique = [];
    for (const img of filtered) {
      if (seen.has(img.url)) continue;
      seen.add(img.url);
      unique.push(img);
      if (unique.length >= 24) break;
    }
 
    // Render thumbnails or dots based on color selector type
    const isTwoColor = colorSelectorType === 'two_color';
    const normalizeUrlForCompare = (url) => {
      if (!url) return '';
      // Compare by base path without query params (width/v/etc.)
      return String(url).split('?')[0].trim();
    };

    // Generic bundle image is only the opening hero. After a colour is selected it stays out of the gallery.
    const activeCardForGen = document.querySelector('.bundle-option-card[aria-selected="true"]');
    const heroUrl = activeCardForGen ? activeCardForGen.getAttribute('data-generic-bundle-image') : null;
    const genericBundleUrl = __showGenericBundleHero ? heroUrl : null;
    if (genericBundleUrl) {
      const genBase = normalizeUrlForCompare(genericBundleUrl);
      const existsIndex = unique.findIndex(i => normalizeUrlForCompare(i.url) === genBase);
      if (existsIndex > 0) {
        const match = unique.splice(existsIndex, 1)[0];
        unique.unshift(match);
      } else if (existsIndex === -1) {
        unique.unshift({ url: genericBundleUrl, alt: 'Generic bundle hero image' });
      }
    } else if (heroUrl) {
      const genBase = normalizeUrlForCompare(heroUrl);
      for (let i = unique.length - 1; i >= 0; i--) {
        if (normalizeUrlForCompare(unique[i].url) === genBase) unique.splice(i, 1);
      }
    }

    // 3-product single-colour bundle: the matching color_X #3set photo is the first gallery image.
    if (colorSelectorType === 'one_color' && activeCardForGen && activeCardForGen.getAttribute('data-3set-hero') === 'true') {
      const parentId = activeCardForGen.getAttribute('data-option-id');
      const checkedUnified = parentId
        ? document.querySelector(`.bundle-one-color[data-parent-id="${parentId}"] input[name="unified-color"]:checked`)
        : null;
      const setUrl = checkedUnified && checkedUnified.getAttribute('data-3set-image') === 'true'
        ? (checkedUnified.getAttribute('data-image') || '')
        : '';
      if (setUrl) {
        const setBase = normalizeUrlForCompare(setUrl);
        for (let i = unique.length - 1; i >= 0; i--) {
          if (normalizeUrlForCompare(unique[i].url) === setBase) unique.splice(i, 1);
        }
        unique.unshift({ url: setUrl, alt: '' });
      }
    }

    // Make sure the currently displayed main image corresponds to the FIRST thumb.
    // This keeps the UI feeling like it "starts from first", while staying in sync.
    const mainImageEl = document.querySelector('.main-product-image');
    const currentMainBase = normalizeUrlForCompare(mainImageEl ? (mainImageEl.getAttribute('src') || mainImageEl.src) : '');
    if (currentMainBase) {
      const matchIndex = unique.findIndex(i => normalizeUrlForCompare(i.url) === currentMainBase);
      if (matchIndex > 0) {
        const match = unique.splice(matchIndex, 1)[0];
        unique.unshift(match);
      }
    }

    unique.forEach((img, idx) => {
      const btn = document.createElement('button');
      btn.type = 'button';
      btn.className = 'bundle-thumb'; 
      btn.setAttribute('role', 'listitem');
      btn.setAttribute('aria-label', `Go to image ${idx + 1}`);
      // Always store the raw image URL for reliable click + active matching
      btn.setAttribute('data-image-url', img.url);
      // Always start with the first thumb active (we reordered `unique` above to match main image when needed)
      if (idx === 0) btn.setAttribute('aria-current', 'true');
      
      if (isTwoColor) {
        // Dots style for two_color selector
        btn.innerHTML = `<img loading="lazy" alt="${img.alt}" src="${img.url}" style="display: none;">`;
      } else {
        // Thumbnail images for one_color selector
        const sep = img.url.indexOf('?') === -1 ? '?' : '&';
        btn.innerHTML = `<img loading="lazy" alt="${img.alt}" src="${img.url}${sep}width=160" srcset="${img.url}${sep}width=160 1x, ${img.url}${sep}width=320 2x">`;
      }
      
      btn.addEventListener('click', () => {
        const targetUrl = btn.getAttribute('data-image-url') || img.url;
        updateMainImage(targetUrl);
        thumbsWrap.querySelectorAll('.bundle-thumb[aria-current="true"]').forEach(n => n.removeAttribute('aria-current'));
        btn.setAttribute('aria-current', 'true');
        updateThirdImageOverlay();
        if (typeof syncBundleGalleryArrowsState === 'function') syncBundleGalleryArrowsState();
      });
      thumbsWrap.appendChild(btn);
    });

    // Append extra images from active card after generated thumbnails
    const activeCardNode = document.querySelector('.bundle-option-card[aria-selected="true"]');
    if (activeCardNode) {
      console.log('Adding extra images for active card:', activeCardNode.getAttribute('data-bundle-option-card'));
      
      const topHandle = activeCardNode.getAttribute('data-top-handle');
      const bottomHandle = activeCardNode.getAttribute('data-bottom-handle');
      const thirdHandle = activeCardNode.getAttribute('data-third-handle');
      
      let extraPrefix = 'top';
      
      if (window.__lastInteractedProductHandle) {
        if (window.__lastInteractedProductHandle === bottomHandle) {
          extraPrefix = 'bottom';
        } else if (window.__lastInteractedProductHandle === thirdHandle) {
          extraPrefix = 'third';
        }
      } else {
        const topProduct = document.querySelector(`bundle-product[data-product-handle="${topHandle}"]`);
        const bottomProduct = document.querySelector(`bundle-product[data-product-handle="${bottomHandle}"]`);
        const thirdProduct = thirdHandle ? document.querySelector(`bundle-product[data-product-handle="${thirdHandle}"]`) : null;
        
        const topHasSelection = topProduct && topProduct.querySelector('input[type="radio"]:checked');
        const bottomHasSelection = bottomProduct && bottomProduct.querySelector('input[type="radio"]:checked');
        const thirdHasSelection = thirdProduct && thirdProduct.querySelector('input[type="radio"]:checked');
        
        if (thirdHasSelection && !topHasSelection && !bottomHasSelection) {
          extraPrefix = 'third';
        } else if (bottomHasSelection && !topHasSelection) {
          extraPrefix = 'bottom';
        }
      }
      
      const extraAttrs = extraPrefix === 'bottom' ? [
        'data-bottom-extra-image-1', 'data-bottom-extra-image-2', 'data-bottom-extra-image-3', 'data-bottom-extra-image-4', 'data-bottom-extra-image-5', 'data-bottom-extra-image-6'
      ] : extraPrefix === 'third' ? [
        'data-third-extra-image-1', 'data-third-extra-image-2', 'data-third-extra-image-3', 'data-third-extra-image-4', 'data-third-extra-image-5', 'data-third-extra-image-6'
      ] : [
        'data-top-extra-image-1', 'data-top-extra-image-2', 'data-top-extra-image-3', 'data-top-extra-image-4', 'data-top-extra-image-5', 'data-top-extra-image-6'
      ];
      
      const appended = [];
      const isTwoColor = colorSelectorType === 'two_color';
      extraAttrs.forEach(attr => {
        const url = activeCardNode.getAttribute(attr);
        if (!url) return;
        console.log('Adding extra image:', attr, url);
        const btn = document.createElement('button');
        btn.type = 'button';
        btn.className = 'bundle-thumb';
        btn.setAttribute('role', 'listitem');
        btn.setAttribute('aria-label', `Go to extra image ${appended.length + 1}`);
        btn.setAttribute('data-image-url', url);
        
        if (isTwoColor) {
          // Dots style for two_color selector
          btn.innerHTML = `<img loading="lazy" alt="" src="${url}" style="display: none;">`;
        } else {
          // Thumbnail images for one_color selector
          const sep = url.indexOf('?') === -1 ? '?' : '&';
          btn.innerHTML = `<img loading="lazy" alt="" src="${url}${sep}width=160" srcset="${url}${sep}width=160 1x, ${url}${sep}width=320 2x">`;
        }
        
        btn.addEventListener('click', () => {
          const targetUrl = btn.getAttribute('data-image-url') || url;
          updateMainImage(targetUrl);
          thumbsWrap.querySelectorAll('.bundle-thumb[aria-current="true"]').forEach(n => n.removeAttribute('aria-current'));
          btn.setAttribute('aria-current', 'true');
          if (typeof syncBundleGalleryArrowsState === 'function') syncBundleGalleryArrowsState();
        });
        thumbsWrap.appendChild(btn);
        appended.push(url);  
      });
      console.log('Total extra images added:', appended.length);
      
    } else {
      
    }

    // No extra "active syncing" needed because we keep main image as thumb #1 above.
    if (typeof syncBundleGalleryArrowsState === 'function') syncBundleGalleryArrowsState();
  }
   // Swipe on main image to navigate bundle thumbs (mobile-friendly)
  function setupBundleGallerySwipe() {
    const img = document.querySelector('.main-product-image');
    if (!img) return;
    if (img.dataset.bundleSwipeBound === 'true') return;
    img.dataset.bundleSwipeBound = 'true';

    let startX = 0;
    let startY = 0;
    let tracking = false;

    const thresholdX = 35; // px
    const thresholdY = 40; // ignore mostly-vertical gestures

    const getThumbButtons = () => Array.from(document.querySelectorAll('#bundle-gallery .bundle-thumb'));

    const clickThumbByOffset = (delta) => {
      const thumbs = getThumbButtons();
      if (!thumbs.length) return;

      const currentIndex = Math.max(
        0,
        thumbs.findIndex(t => t.getAttribute('aria-current') === 'true')
      );
      const idx = (currentIndex === -1 ? 0 : currentIndex) + delta;
      const next = thumbs[Math.max(0, Math.min(thumbs.length - 1, idx))];
      if (next) next.click();
    };

    img.addEventListener('touchstart', (e) => {
      if (!e.touches || e.touches.length !== 1) return;
      const t = e.touches[0];
      startX = t.clientX;
      startY = t.clientY;
      tracking = true;
    }, { passive: true });

    img.addEventListener('touchend', (e) => {
      if (!tracking) return;
      tracking = false;
      const t = (e.changedTouches && e.changedTouches[0]) ? e.changedTouches[0] : null;
      if (!t) return;

      const dx = t.clientX - startX;
      const dy = t.clientY - startY;
      if (Math.abs(dy) > thresholdY && Math.abs(dy) > Math.abs(dx)) return;
      if (Math.abs(dx) < thresholdX) return;

      // swipe left => next, swipe right => prev
      if (dx < 0) clickThumbByOffset(1);
      else clickThumbByOffset(-1);
    }, { passive: true });
  }

  setupBundleGallerySwipe();

  function syncBundleGalleryArrowsState() {
    const thumbs = Array.from(document.querySelectorAll('#bundle-gallery .bundle-thumb'));
    const prevBtn = document.querySelector('[data-bundle-gallery-prev]');
    const nextBtn = document.querySelector('[data-bundle-gallery-next]');
    if (!thumbs.length || !prevBtn || !nextBtn) return;
    const currentIndex = thumbs.findIndex(function(t) { return t.getAttribute('aria-current') === 'true'; });
    const index = currentIndex < 0 ? 0 : currentIndex;
    const total = thumbs.length;
    const isFirst = total <= 1 || index <= 0;
    const isLast = total <= 1 || index >= total - 1;
    prevBtn.classList.toggle('bundle-gallery-arrow--inactive', isFirst);
    nextBtn.classList.toggle('bundle-gallery-arrow--inactive', isLast);
    prevBtn.setAttribute('aria-disabled', isFirst ? 'true' : 'false');
    nextBtn.setAttribute('aria-disabled', isLast ? 'true' : 'false');
  }

  // New UX (two_color): bottom-right arrows should navigate the same internal gallery state.
  // Keep JS minimal: just click prev/next hidden `.bundle-thumb` buttons.
  function clickBundleThumbByOffset(delta) {
    const thumbs = Array.from(document.querySelectorAll('#bundle-gallery .bundle-thumb'));
    if (!thumbs.length) return;
    let currentIndex = thumbs.findIndex(t => t.getAttribute('aria-current') === 'true');
    if (currentIndex < 0) currentIndex = 0;
    const nextIndex = Math.max(0, Math.min(thumbs.length - 1, currentIndex + delta));
    const next = thumbs[nextIndex];
    if (next) next.click();
  }

  // Use capture phase so we intercept before other click handlers.
  document.addEventListener('click', (e) => {
    const prev = e.target.closest('[data-bundle-gallery-prev]');
    const next = e.target.closest('[data-bundle-gallery-next]');
    if (!prev && !next) return;
    e.preventDefault();
    e.stopPropagation();
    e.stopImmediatePropagation();
    clickBundleThumbByOffset(prev ? -1 : 1);
    syncBundleGalleryArrowsState();
  }, true);

  // A real colour click leaves the generic bundle image and uses the existing gallery.
  document.addEventListener('click', (e) => {
    if (!__showGenericBundleHero || getColorSelectorType() !== 'two_color') return;
    const swatch = e.target.closest('.variant-swatch');
    if (!swatch || !swatch.closest('bundle-product')) return;
    const input = swatch.querySelector('input[type="radio"]');
    __showGenericBundleHero = false;
    if (input && input.checked) {
      input.dispatchEvent(new Event('change', { bubbles: true }));
    }
  }, true);

  // Add event listeners to all color swatches
  colorSwatches.forEach(swatch => {
    swatch.addEventListener('change', function() {
      if (this.name === 'unified-color') return;
      const productContainer = this.closest('bundle-product');
      const mainImage = document.querySelector('.main-product-image');
      // Prefer metafield-mapped large image (`data-image`).
      // Fallback to variant image sources when `data-image` is not present (prevents "main image not changing").
      const swatchWrap = this.closest('.variant-swatch');
      const swatchSpan = swatchWrap ? swatchWrap.querySelector('.variant-swatch__color') : null;
      const imageUrl =
        this.getAttribute('data-image') ||
        (swatchSpan ? swatchSpan.getAttribute('data-variant-image') : null) ||
        this.getAttribute('data-image-url');
      const productHandler = this.getAttribute('data-product-handle');
      if (!__syncingBundleColors) {
        __lastGalleryProductHandle = productHandler || (productContainer ? productContainer.getAttribute('data-product-handle') : null);
        if (productHandler) {
          window.__lastInteractedProductHandle = productHandler;
        } else if (productContainer) {
          window.__lastInteractedProductHandle = productContainer.getAttribute('data-product-handle');
        }
      }
      var variantIdLink = this.getAttribute('data-variant-id');
      updateProductLinks(productContainer, variantIdLink);
      const selectedColorVar = this.value;
      let colorNameElement = productContainer?.querySelector('.color_name');
      sizeSwatchFetch(selectedColorVar, productHandler, productContainer)
      
      if (colorNameElement) {
        colorNameElement.textContent = selectedColorVar;
      }
      
      if (!__syncingBundleColors) {
        updateUrlWithColors();
      }
      
      // Update SALE badges when color changes
      // updateSaleBadgesOnColorSwatches();
 
        
      // Update the main image for both modes using a single path that correctly handles width params.
      if (!__syncingBundleColors && mainImage && imageUrl) {
        updateMainImage(imageUrl);
      }
      
      if (productContainer) {
        const productId = productContainer.getAttribute('data-block-id');
        updateVariantId(productContainer);
        updateProductImage(productContainer, productId, this);
      }
      if (!__syncingBundleColors) {
        rebuildBundleGallery();
      }
      try { showDiscountAppliedForInput(this); } catch(e) {}
      // Recompute totals when color changes
      scheduleTotalsCompute();
      
      // Update individual product prices with discount
      if (productContainer) {
        // Wait for size buttons to be updated, then find the first available size
        setTimeout(() => {
          const sizeButtons = productContainer.querySelectorAll('.product-variant-size-button:not(.hidden)');
          let selectedSizeButton = null;
          
          // First, try to find an already selected size button
          const currentlySelected = productContainer.querySelector('.product-variant-size-button.selected');
          if (currentlySelected && !currentlySelected.disabled && currentlySelected.getAttribute('data-available') === 'true') {
            selectedSizeButton = currentlySelected;
          } else {
            // If no valid selection, find the first available size
            for (const button of sizeButtons) {
              if (!button.disabled && button.getAttribute('data-available') === 'true') {
                selectedSizeButton = button;
                // Auto-select the first available size
                productContainer.querySelectorAll('.product-variant-size-button').forEach(btn => btn.classList.remove('selected'));
                button.classList.add('selected');
                break;
              }
            }
          }
          
          // Update price based on selected size or fallback to color data
          if (selectedSizeButton) {
            updatePriceAndAvailability(productContainer, {
              price: parseFloat(selectedSizeButton.getAttribute('data-price') || 0),
              comparePrice: parseFloat(selectedSizeButton.getAttribute('data-compare-price') || 0),
              available: selectedSizeButton.getAttribute('data-available') === 'true'
            });
            
            // Update variant input
            const variantInput = productContainer.querySelector('.product-variant-id');
            if (variantInput) {
              variantInput.value = selectedSizeButton.getAttribute('data-variant-id');
            }
          } else {
            // Fallback to color input data if no size is available
            const colorInput = productContainer.querySelector('input[type="radio"]:checked');
            if (colorInput) {
              updatePriceAndAvailability(productContainer, {
                price: parseFloat(colorInput.getAttribute('data-price') || 0),
                comparePrice: parseFloat(colorInput.getAttribute('data-compare-price') || 0),
                available: colorInput.getAttribute('data-available') === 'true'
              });
            }
          }
        }, 100); // Small delay to ensure size buttons are updated
      }
    });
  });

  document.addEventListener('click', function(event){
    const btn = event.target.closest('.product-variant-size-button');
    if (!btn) return;
    if (btn.disabled) return;
    const productContainer = btn.closest('bundle-product');
    if (!productContainer) return;
    event.preventDefault();

    productContainer.querySelectorAll('.product-variant-size-button').forEach(b => b.classList.remove('selected'));
    btn.classList.add('selected');
    const variantInput = productContainer.querySelector('.product-variant-id');
    if (variantInput) {
      variantInput.value = btn.getAttribute('data-variant-id');
    }
      // Recompute bundle totals after size change (batched)
      scheduleTotalsCompute();
      // Ensure discount badge remains accurate after size change
      const checkedColor = productContainer.querySelector('input[type="radio"]:checked');
      if (checkedColor) {
        try { showDiscountAppliedForInput(checkedColor); } catch(e) {}
      }
  }, true);

  // Handle the bundle form submission
  if (bundleForm) {
    bundleForm.addEventListener('submit', (e) => {
      e.preventDefault();
      
      // Validate size selection
      const { allSizesSelected, dataId , errorMessage: sizeError } = validateSizeSelection();
      if (!allSizesSelected) {
        const errorElement = document.querySelector('.product-form__error-message');
        if (errorElement) {
          errorElement.textContent = sizeError;
          document.querySelector('.product-form__error-message-wrapper').style.display = 'block';
        }
        
        return;
      }

      // Hide error message if validation passes
      document.querySelector('.product-form__error-message-wrapper').style.display = 'none';
      
      // Get all selected variants
      const selectedVariants = [];
      const colorSelectorType = getColorSelectorType();
      
      if (colorSelectorType === 'one_color') {
        // For one-color selector, get variants from unified color input and size selections
        const unifiedColorInput = document.querySelector('input[name="unified-color"]:checked');
        if (unifiedColorInput) {
          const selectedColor = unifiedColorInput.value;
          const activeCard = document.querySelector('.bundle-option-card[aria-selected="true"]');
          const activeId = activeCard ? activeCard.getAttribute('data-option-id') : dataId;
          
          if (activeId) {
            ['-top', '-bottom', '-third'].forEach((suffix) => {
              const productEl = document.querySelector(`bundle-product[data-parent-id="${activeId}"][data-block-id*="${suffix}"]`);
              const item = collectOneColorVariant(productEl, selectedColor);
              if (item) selectedVariants.push(item);
            });
          }
        }
      } else {
        const containers = dataId
          ? document.querySelectorAll('bundle-product[data-parent-id="'+ dataId +'"]')
          : document.querySelectorAll('bundle-product');
        containers.forEach(productContainer => {
          if (productContainer.style.display === 'none' || getComputedStyle(productContainer).display === 'none') return;
          const selectedSize = productContainer.querySelector('.product-variant-size-button.selected');
          const variantId = selectedSize ? selectedSize.getAttribute('data-variant-id') : null;
          if (variantId) {
            selectedVariants.push({
              id: variantId,
              quantity: 1
            });
          }
        });
      }

      if (!selectedVariants.length) {
        const errorElement = document.querySelector('.product-form__error-message');
        if (errorElement) {
          errorElement.textContent = 'Please select size for all products';
          document.querySelector('.product-form__error-message-wrapper').style.display = 'block';
        }
        return;
      }

      // Create form data with selected variants
      const formData = new FormData();
      selectedVariants.forEach((variant, index) => {
        formData.append(`items[${index}][id]`, variant.id);
        formData.append(`items[${index}][quantity]`, variant.quantity);
      });
      fetch('/cart/add.js', {
        method: 'POST',
        body: formData
      })
      .then(response => {
        if (!response.ok) throw new Error('Unable to add items to cart.');
        return response.json();
      })
      .then(data => {
        if (typeof window.openCartDrawer === 'function') {
          window.openCartDrawer();
        } else if (typeof Shopify.theme.cartDrawer !== 'undefined') {
          Shopify.theme.cartDrawer.open();
        } else {
          handleFloCartBtn();
        }
      })
      .catch(error => {
        console.error('Error:', error);
        const errorMessageWrapper = document.querySelector('.product-form__error-message-wrapper');
        const errorMessage = document.querySelector('.product-form__error-message');
        
        if (errorMessageWrapper && errorMessage) {
          errorMessage.textContent = error.message || 'An error occurred while adding items to cart.';
          errorMessageWrapper.style.display = 'block';
          
          setTimeout(() => {
            errorMessageWrapper.style.display = 'none';
          }, 5000);
        }
      });
    });
  }

  // Function to update main image
  function updateMainImage(imageUrl) {
    const mainImage = document.querySelector('.main-product-image');
    if (mainImage && imageUrl) {
      // Important: don't append another "&width=" to a URL that already contains width=150 etc.
      // That behavior causes the browser to load the small image and upscale it (blurry).
      const withWidth = (url, w) => {
        const str = String(url).trim();
        if (!str) return '';
        const [base, qs = ''] = str.split('?');
        const params = new URLSearchParams(qs);
        params.set('width', String(w));
        const q = params.toString();
        return q ? `${base}?${q}` : base;
      };

      mainImage.src = withWidth(imageUrl, 1500);

      // Set responsive srcset
      mainImage.srcset = `
        ${withWidth(imageUrl,165)} 165w,
        ${withWidth(imageUrl,360)} 360w,
        ${withWidth(imageUrl,535)} 535w,
        ${withWidth(imageUrl,750)} 750w,
        ${withWidth(imageUrl,1100)} 1100w,
        ${withWidth(imageUrl,1500)} 1500w
      `.trim();
      
      // Update hotspots visibility after image changes
      updateHotspotsVisibility();
      // Update 3rd image overlay visibility
      updateThirdImageOverlay();
    }
  }

  function updateThirdImageOverlay() {
    const overlay = document.getElementById('bundle-third-image-overlay');
    const activeCard = document.querySelector('.bundle-option-card[aria-selected="true"]');
    const thumbsWrap = document.querySelector('#bundle-gallery .bundle-thumbs');
    const activeThumb = thumbsWrap?.querySelector('.bundle-thumb[aria-current="true"]');
    
    if (!overlay || !activeCard || !thumbsWrap || !activeThumb || activeCard.getAttribute('data-third-overlay-enable') !== 'true') {
      overlay?.classList.remove('is-visible');
      overlay?.setAttribute('aria-hidden', 'true');
      return;
    }

    const currentIndex = Array.from(thumbsWrap.querySelectorAll('.bundle-thumb')).indexOf(activeThumb);
    const isThirdImage = currentIndex === 1;

    if (isThirdImage) {
      [1, 2, 3, 4].forEach(i => {
        const text = activeCard.getAttribute(`data-third-overlay-text-${i}`) || '';
        const slot = overlay.querySelector(`[data-third-overlay-slot="${i}"] .bundle-third-image-overlay__text`);
        if (slot) slot.textContent = text;
      });
      overlay.classList.add('is-visible');
      overlay.setAttribute('aria-hidden', 'false');
    } else {
      overlay.classList.remove('is-visible');
      overlay.setAttribute('aria-hidden', 'true');
    }
  }

  // Add event listeners for women's color variants
  const womenColorVariants = document.querySelectorAll('.women_color_variants input[type="radio"]');
  womenColorVariants.forEach(swatch => {
    swatch.addEventListener('change', function() {
      const preferredByProduct = new Map();
      document.querySelectorAll('bundle-product').forEach((bp) => {
        const label = getSelectedSizeLabel(bp);
        if (label) preferredByProduct.set(bp, label);
      });

      const imageUrl = this.getAttribute('data-image');
      if (imageUrl) {
        updateMainImage(imageUrl);
      }
      try { showDiscountAppliedForInput(this); } catch(e) {}
      // Recompute totals when unified color changes
      scheduleTotalsCompute();
      
      // Update individual product prices with discount for unified color selector
      const productContainers = document.querySelectorAll('bundle-product');
      productContainers.forEach(productContainer => {
        // Wait for size buttons to be updated, then find the first available size
        setTimeout(() => {
          const preferredSize = preferredByProduct.get(productContainer);
          const sizeButtons = productContainer.querySelectorAll('.product-variant-size-button:not(.hidden)');
          let selectedSizeButton = null;
          
          // First, try to find an already selected size button
          const currentlySelected = productContainer.querySelector('.product-variant-size-button.selected:not(.hidden)');
          if (currentlySelected && !currentlySelected.disabled && currentlySelected.getAttribute('data-available') === 'true') {
            selectedSizeButton = currentlySelected;
          } else if (preferredSize) {
            for (const button of sizeButtons) {
              const sizeLabel = button.getAttribute('aria-label') || button.textContent.trim().split(' - ')[0];
              if (sizeLabel === preferredSize && !button.disabled && button.getAttribute('data-available') === 'true') {
                selectedSizeButton = button;
                productContainer.querySelectorAll('.product-variant-size-button').forEach(btn => btn.classList.remove('selected'));
                button.classList.add('selected');
                break;
              }
            }
          }

          if (!selectedSizeButton) {
            // If no valid selection, find the first available size
            for (const button of sizeButtons) {
              if (!button.disabled && button.getAttribute('data-available') === 'true') {
                selectedSizeButton = button;
                productContainer.querySelectorAll('.product-variant-size-button').forEach(btn => btn.classList.remove('selected'));
                button.classList.add('selected');
                break;
              }
            }
          }
          
          // Update price based on selected size or fallback to color data
          if (selectedSizeButton) {
            updatePriceAndAvailability(productContainer, {
              price: parseFloat(selectedSizeButton.getAttribute('data-price') || 0),
              comparePrice: parseFloat(selectedSizeButton.getAttribute('data-compare-price') || 0),
              available: selectedSizeButton.getAttribute('data-available') === 'true'
            });
            
            // Update variant input
            const variantInput = productContainer.querySelector('.product-variant-id');
            if (variantInput) {
              variantInput.value = selectedSizeButton.getAttribute('data-variant-id');
            }
          } else {
            // Fallback to color input data if no size is available
            const colorInput = productContainer.querySelector('input[type="radio"]:checked');
            if (colorInput) {
              updatePriceAndAvailability(productContainer, {
                price: parseFloat(colorInput.getAttribute('data-price') || 0),
                comparePrice: parseFloat(colorInput.getAttribute('data-compare-price') || 0),
                available: colorInput.getAttribute('data-available') === 'true'
              });
            }
          }
        }, 100); // Small delay to ensure size buttons are updated
      });
      
      // Update URL with new color selection
      updateUrlWithColors();
    });
  });

  // Add event listeners for two-color variation swatches
  // const twoColorSwatches = document.querySelectorAll('.two-color-variation-swatch input[type="radio"]');
  // twoColorSwatches.forEach(swatch => {
  //   swatch.addEventListener('change', function() {
  //     const imageUrl = this.getAttribute('data-image-url');
  //     if (imageUrl) {
  //       updateMainImage(imageUrl);
  //     }
  //     try { showDiscountAppliedForInput(this); } catch(e) {}
  //   });
  // });

  // Function to check if all products have size selected
  function validateSizeSelection() {
    let allSizesSelected = true;
    let errorMessage = '';
    const activeBlock = document.querySelector('.bundle-option-card[aria-selected="true"]'); 
    
    if(!activeBlock) return { allSizesSelected: false, dataId: null, errorMessage: 'Please select a bundle option' };
    const id = activeBlock.getAttribute('data-option-id')
    const productContainers = document.querySelectorAll('bundle-product[data-parent-id="'+ id +'"]');
    
    productContainers.forEach(container => {
      if (container.style.display === 'none' || getComputedStyle(container).display === 'none') return;
      const selectedSize = container.querySelector('.product-variant-size-button.selected');
      if (!selectedSize) {
        allSizesSelected = false;
        errorMessage = 'Please select size for all products';
      }
    });

    return { allSizesSelected, dataId: id  , errorMessage };
  }

  function updateProductImage(productContainer, productId, selectedInput) {
    const productImage = document.getElementById(`product-image-${productId}`);
      
    if (productImage) {
      // Get the variant image URL from the selected color swatch
      const colorSwatch = selectedInput.nextElementSibling;
      const imageUrl = colorSwatch.getAttribute('data-variant-image');
      const imageUrl2x = colorSwatch.getAttribute('data-variant-image-2x');
      
      if (imageUrl) {
        // Update the image src and srcset
        productImage.setAttribute('src', imageUrl);
        productImage.setAttribute('srcset', `${imageUrl} 1x, ${imageUrl2x} 2x`);
        
        // Add a smooth transition effect
        productImage.style.opacity = '0';
        setTimeout(() => {
          productImage.style.opacity = '1';
        }, 50);

        // Check if this product should update the large image
        const blockId = productContainer.getAttribute('data-block-id');
        const block = document.querySelector(`[data-block-id="${blockId}"]`);
        if (!__syncingBundleColors && getColorSelectorType() !== 'one_color' && block && block.hasAttribute('data-show-large-image')) {
          // Use the central main-image updater (handles width params properly).
          updateMainImage(imageUrl);
        }
      }
    }
  }
    
    // Function to find the correct variant based on all selected options
    function findMatchingVariant(productContainer) {
      // Get all selected options for this product
      const selectedColor = productContainer.querySelector('input[type="radio"]:checked');
      const selectedSize = productContainer.querySelector('select');
      
      if (!selectedColor || !selectedSize) return null;
      
      const colorValue = selectedColor.value;
      const sizeValue = selectedSize.value;
      
      // Find the matching variant option in the size dropdown
      const matchingOption = Array.from(selectedSize.options).find(option => 
        option.value === sizeValue && 
        option.closest('select-wrapper').previousElementSibling.querySelector(`input[value="${colorValue}"]`)
      );
      
      // If we found a matching option with both color and size
      if (matchingOption) {
        return {
          id: matchingOption.getAttribute('data-variant-id'),
          price: parseFloat(matchingOption.getAttribute('data-price') || 0),
          comparePrice: parseFloat(matchingOption.getAttribute('data-compare-price') || 0),
          available: matchingOption.getAttribute('data-available') === 'true'
        };
      }
      
      // If no exact match found, try to find the variant directly from the size dropdown
      const sizeOption = selectedSize.options[selectedSize.selectedIndex];
      if (sizeOption && sizeOption.getAttribute('data-variant-id')) {
        return {
          id: sizeOption.getAttribute('data-variant-id'),
          price: parseFloat(sizeOption.getAttribute('data-price') || 0),
          comparePrice: parseFloat(sizeOption.getAttribute('data-compare-price') || 0),
          available: sizeOption.getAttribute('data-available') === 'true'
        };
      }
      
      return null;
    }
    
    // Function to update the variant ID and price based on selected options
    function updateVariantId(productContainer) {
      const productId = productContainer.getAttribute('data-block-id');
      const variantInput = productContainer.querySelector('.product-variant-id');
      const selectedColorInput = productContainer.querySelector('input[type="radio"]:checked');
      const selectedSizeButton = productContainer.querySelector('.product-variant-size-button.selected');
      
      if (!variantInput || !selectedColorInput) return;
      
      // Try to find a variant that matches both color and size
      if (selectedSizeButton) {
        const variantId = selectedSizeButton.getAttribute('data-variant-id');
        variantInput.value = variantId;
        
        // Update add-to-cart button
        const addToCartBtn = productContainer.querySelector('add-to-cart');
        if (addToCartBtn) {
          addToCartBtn.setAttribute('data-variant-id', variantId);
          
        }
        
        // Update price using the data from the selected size button
        updatePriceAndAvailability(productContainer, {
          price: parseFloat(selectedSizeButton.getAttribute('data-price') || 0),
          comparePrice: parseFloat(selectedSizeButton.getAttribute('data-compare-price') || 0),
          available: selectedSizeButton.getAttribute('data-available') === 'true'
        });
        
        // Update product image if needed
        updateProductImage(productContainer, productId, selectedColorInput);
        
        return;
      }
      
      // Fallback to just using the color variant if no size is selected
      const variantId = selectedColorInput.getAttribute('data-variant-id');
      variantInput.value = variantId;
      
      // Update add-to-cart button
      const addToCartBtn = productContainer.querySelector('add-to-cart');
      if (addToCartBtn) {
        addToCartBtn.setAttribute('data-variant-id', variantId);
      }
      
      // Update price using the data from the selected color
      updatePriceAndAvailability(productContainer, {
        price: parseFloat(selectedColorInput.getAttribute('data-price') || 0),
        comparePrice: parseFloat(selectedColorInput.getAttribute('data-compare-price') || 0),
        available: selectedColorInput.getAttribute('data-available') === 'true'
      });
      
      // Update product image
      updateProductImage(productContainer, productId, selectedColorInput);
      
      // Recompute totals after variant update
      scheduleTotalsCompute();
    }
    
    // Function to update the product image
    function updateProductImage(productContainer, productId, selectedInput) {
      const productImage = document.getElementById(`product-image-${productId}`);
      if (productImage) {
        const imageUrl = selectedInput.getAttribute('data-image-url');
        const imageUrl2x = selectedInput.getAttribute('data-image-url-2x') || 
                         (imageUrl ? imageUrl.replace('_70x', '_140x') : null);
        
        if (imageUrl) {
          productImage.src = imageUrl;
          productImage.srcset = `${imageUrl} 1x, ${imageUrl2x || imageUrl} 2x`;
        }
      }
    }
    
    // Function to update price and availability status with discount support
    function updatePriceAndAvailability(productContainer, variantData) {
      // Determine the product id from any price container within this bundle-product
      const anyPriceContainer = productContainer.querySelector('.product-price-container');
      if (!anyPriceContainer) return;

      const productId = anyPriceContainer.getAttribute('data-product-id');
      if (!productId) return;

      // Find and update ALL price containers for this product (desktop + mobile + inline)
      const priceContainers = document.querySelectorAll(`.product-price-container[data-product-id="${productId}"]`);

      const isAvailable = variantData.available === true;
      const price = variantData.price || 0;
      const comparePrice = variantData.comparePrice || 0;

      // Get selected color for discount calculation
      const colorInput = productContainer.querySelector('input[type="radio"]:checked');
      const selectedColorValue = colorInput ? (colorInput.value || '') : '';
      
      // Determine side (top/bottom) for discount lookup
      const activeCard = document.querySelector('.bundle-option-card[aria-selected="true"]');
      let side = getBundleProductSide(productContainer, activeCard);

      // Calculate discount
      const appliedPercent = selectedColorValue ? getColorDiscountForActiveCard(selectedColorValue, side) : 0;
      const discountCents = Math.round(price * (appliedPercent / 100));
      const discountedPrice = price - discountCents;

      // Format prices with currency
      const formattedOriginalPrice = formatMoney(price);
      const formattedDiscountedPrice = formatMoney(discountedPrice);
      const formattedComparePrice = formatMoney(comparePrice);

      const hasComparePrice = comparePrice > 0 && comparePrice > price;
      const hasDiscount = appliedPercent > 0 && discountCents > 0;

      priceContainers.forEach((priceContainer) => {
        // Update prices with discount support
        const regularPriceElement = priceContainer.querySelector('.product-regular-price');
        const salePriceElement = priceContainer.querySelector('.product-sale-price');
        const comparePriceElement = priceContainer.querySelector('.product-compare-price');

        if (regularPriceElement && price) {
          if (hasDiscount) {
            // Show original price with strikethrough and discounted price only when discount is applied
            regularPriceElement.innerHTML = `<span class="product-original-price" style="text-decoration: line-through; color: #999; margin-right: 8px;">${formattedOriginalPrice}</span><span class="product-discounted-price" style="color: #e74c3c; font-weight: bold;">${formattedDiscountedPrice}</span>`;
          } else {
            // Show regular price normally when no discount is applied
            regularPriceElement.innerHTML = formattedOriginalPrice;
          }
        }

        // Only update sale price element if it exists and we have a discount
        if (salePriceElement && price && hasDiscount) {
          salePriceElement.innerHTML = formattedDiscountedPrice;
        } else if (salePriceElement && price && !hasDiscount) {
          // Hide or clear sale price when no discount
          salePriceElement.innerHTML = '';
        }

        if (comparePriceElement) {
          // If there is no valid compare at price, clear it so UI toggles correctly
          comparePriceElement.innerHTML = hasComparePrice ? formattedComparePrice : '';
        }

        // Update sold-out status
        // if (isAvailable) {
        //   priceContainer.classList.remove('price--sold-out');
        // } else {
        //   priceContainer.classList.add('price--sold-out');
        // }

        // Update sale status 
        if ((hasComparePrice || hasDiscount) && isAvailable) {
          priceContainer.classList.add('price--on-sale');
        } else {
          priceContainer.classList.remove('price--on-sale');
        }
      });
    }
    
    // Helper function to format money values
 function formatMoney(cents) {
      const num = typeof cents === 'string' ? Number.parseFloat(cents) : cents;
      if (isNaN(num) || num === 0) return '₹0';
      const centsInt = Math.round(num);
      const rupees = centsInt / 100;
      const isWholeRupee = centsInt % 100 === 0;
      return '₹' + rupees.toLocaleString(
        'en-IN',
        isWholeRupee
          ? { minimumFractionDigits: 0, maximumFractionDigits: 0 }
          : { minimumFractionDigits: 2, maximumFractionDigits: 2 }
      );
    }

  // Add event listeners to all size buttons
  sizeButtons.forEach(button => {
    button.addEventListener('click', function(event) {
      event.preventDefault();
      if (this.disabled) return;
      
      const productContainer = this.closest('bundle-product');
      if (productContainer) {
        // Remove selected class from all buttons in the same product
        productContainer.querySelectorAll('.product-variant-size-button').forEach(btn => {
          btn.classList.remove('selected');
        });
        
        // Add selected class to clicked button
        this.classList.add('selected');
        
        // Update variant ID without changing color selection
        const variantInput = productContainer.querySelector('.product-variant-id');
        if (variantInput) {
          variantInput.value = this.getAttribute('data-variant-id');
        }
      }
    });
  });

  // Initialize all products with their default selected options
  document.querySelectorAll('bundle-product').forEach(productContainer => {
    updateVariantId(productContainer);
  });
  ensureActiveTabSelections();
  if (getColorSelectorType() === 'two_color') {
    syncActiveTabColorAndSizes();
  } else {
    selectFirstColorForActiveTab();
  }
  // Calculate initial bundle total
  scheduleTotalsCompute();
  updateMainImageFromActiveColor();
  
  // Update 3rd image overlay on initial load (after gallery is set up)
  setTimeout(() => updateThirdImageOverlay(), 300);
  
  // Format Liquid-rendered prices with commas on page load
  formatLiquidRenderedPrices();
  
  // Format prices again after a short delay to catch any dynamically loaded content
  setTimeout(() => {
    formatLiquidRenderedPrices();
  }, 500);
  // Function to find matching variant based on color and size
  function findMatchingVariants(productContainer, selectedColor, selectedSize) {
    const productId = productContainer.getAttribute('data-block-id');
    const variants = productContainer.querySelectorAll('input[type="radio"]');
    const sizeButtons = productContainer.querySelectorAll('.product-variant-size-button');
    
    // Find the color variant that matches the selected color
    const colorVariant = Array.from(variants).find(variant => 
      variant.value === selectedColor
    );
    
    if (!colorVariant) return null;
    
    // Get all variants for this product
    const productVariants = [];
    sizeButtons.forEach(button => {
      const variantId = button.getAttribute('data-variant-id');
      const price = button.getAttribute('data-price');
      const comparePrice = button.getAttribute('data-compare-price');
      const available = button.getAttribute('data-available');
      const size = button.textContent.trim().split(' - ')[0]; // Remove " - Sold Out" if present
      
      if (variantId) {
        productVariants.push({
          id: variantId,
          size: size,
          price: parseFloat(price || 0),
          comparePrice: parseFloat(comparePrice || 0),
          available: available === 'true'
        });
      }
    });
    
    // Find the variant that matches both color and size
    const matchingVariant = productVariants.find(variant => 
      variant.size === selectedSize
    );
    
    return matchingVariant || null;
  }
  // Add unified color selector functionality for women's products
    const color_selector_type = getColorSelectorType();
    if (color_selector_type === 'one_color') {
      const unifiedColorInputs = document.querySelectorAll('input[name="unified-color"]');
      unifiedColorInputs.forEach(input => {
        input.addEventListener('change', function() {
          const activeCard = document.querySelector('.bundle-option-card[aria-selected="true"]');
          if (activeCard) {
            const activeCardId = activeCard.getAttribute('data-option-id');
            if (activeCardId) {
              window.__userHasSelectedColorForCard = window.__userHasSelectedColorForCard || {};
              window.__userHasSelectedColorForCard[activeCardId] = true;
            }
          }
          const selectedColor = this.value;
          const productHandler = this.getAttribute('data-product-handle');
          const variantID = this.getAttribute('data-variant-id')
          const swatchWrap = this.closest('.variant-swatch');
          const swatchSpan = swatchWrap ? swatchWrap.querySelector('.variant-swatch__color') : null;
          const imageUrl = this.getAttribute('data-image') ||
            (swatchSpan ? swatchSpan.getAttribute('data-variant-image') : null) ||
            this.getAttribute('data-image-url');
           
          // Track which product is being interacted with for extra image filtering
          if (productHandler) {
            window.__lastInteractedProductHandle = productHandler;
          }
            
          let containerSwatch = this.closest('.bundle-one-color')
          let colorNameElement = containerSwatch.querySelector('.color_name');
          sizeSwatchFetch(selectedColor)
        // Ensure the color_name element exists and update it
        if (colorNameElement) {
          colorNameElement.textContent = selectedColor;
        }
        
        // Update URL with new color selection
        updateUrlWithColors();
        
        // Show discount badge for unified color selector
        showDiscountAppliedForInput(this);
        
        // Show discount badges after product titles for one-color selector
        showDiscountAfterProductTitle();
        
        // Update SALE badges when unified color changes
        // updateSaleBadgesOnColorSwatches();
          
          if (imageUrl) {
            updateMainImage(imageUrl);
          }
          rebuildBundleGallery();
           // Update all product images
           document.querySelectorAll('bundle-product').forEach(productContainer => {
             const productId = productContainer.getAttribute('data-block-id');
             const productImage = productContainer.querySelector('.product-image__img');
             
             if (productImage) {
               // Find the matching variant for this product and selected color
               const productVariants = productContainer.querySelectorAll('input[type="radio"]');
               const matchingVariant = Array.from(productVariants).find(variant => 
                 variant.value === selectedColor
               );
                if (matchingVariant) {
                  const variantId = matchingVariant.getAttribute('data-variant-id');
                  updateProductLinks(productContainer, variantId);
                  
                  // Check the matching color input in this product container
                  matchingVariant.checked = true;
                  
                  // Update image
                  const imageUrl = matchingVariant.getAttribute('data-image-url');
                  const imageUrl2x = matchingVariant.getAttribute('data-image-url-2x');
                  
                  productImage.src = imageUrl;
                  productImage.srcset = `${imageUrl} 1x, ${imageUrl2x} 2x`;
                  
                  // Update variant ID
                  const variantInput = productContainer.querySelector('.product-variant-id');
                  if (variantInput) {
                    variantInput.value = variantId;
                  }
                  
                  // Update add-to-cart button
                  const addToCartBtn = productContainer.querySelector('add-to-cart');
                  if (addToCartBtn) {
                    addToCartBtn.setAttribute('data-variant-id', variantId);
                  }
                  
                  // Update price
                  updatePriceAndAvailability(productContainer, {
                    price: parseFloat(matchingVariant.getAttribute('data-price') || 0),
                    comparePrice: parseFloat(matchingVariant.getAttribute('data-compare-price') || 0),
                    available: matchingVariant.getAttribute('data-available') === 'true'
                  });

                  // Show discount badge for this color
                  showDiscountAppliedForInput(matchingVariant);
                 
                 // Update size buttons availability
                 const sizeButtons = productContainer.querySelectorAll('.product-variant-size-button');
                 sizeButtons.forEach(button => {
                   const buttonSize = button.textContent.trim();
                   const matchingVariant = findMatchingVariants(productContainer, selectedColor, buttonSize);
                
                   if (matchingVariant) {
                     button.disabled = !matchingVariant.available;
                     button.setAttribute('data-variant-id', matchingVariant.id);
                     button.setAttribute('data-price', matchingVariant.price);
                     button.setAttribute('data-compare-price', matchingVariant.comparePrice);
                     button.setAttribute('data-available', matchingVariant.available);
                     
                     // Update button appearance based on availability
                     if (matchingVariant.available) {
                       button.classList.remove('disabled');
                       button.removeAttribute('disabled');
                     } else {
                       button.classList.add('disabled');
                       button.setAttribute('disabled', 'disabled');
                     }
                   } else {
                     button.disabled = true;
                     button.classList.add('disabled');
                     button.setAttribute('disabled', 'disabled');
                   }
                 });
                }
             }
           });
            scheduleTotalsCompute();
         });
      });

      selectFirstColorForActiveTab();
    }
  // ... existing code ...


  
  // Add new functionality for color matching
  function syncColorsAcrossProducts() {
    const allProducts = document.querySelectorAll('bundle-product');
    const byParent = new Map();

    allProducts.forEach(product => {
      const parentId = product.getAttribute('data-parent-id') || '';
      if (!byParent.has(parentId)) byParent.set(parentId, []);
      byParent.get(parentId).push(product);
    });

    byParent.forEach((products) => {
      const colorMap = new Map();

      products.forEach(product => {
        const colorInputs = product.querySelectorAll('input[type="radio"]');
        colorInputs.forEach(input => {
          const color = input.value;
          if (!colorMap.has(color)) {
            colorMap.set(color, new Set());
          }
          colorMap.get(color).add(product);
        });
      });

      colorMap.forEach((productSet, color) => {
        if (productSet.size < products.length) {
          products.forEach(product => {
            const colorInput = product.querySelector(`input[type="radio"][value="${color}"]`);
            if (colorInput) {
              const swatch = colorInput.closest('.variant-swatch');
              if (swatch) {
                swatch.style.display = 'none';
              }
            }
          });
        }
      });
    });
  }

  // Add new functionality to maintain selected colors
  function maintainSelectedColors() {
    const allProducts = document.querySelectorAll('bundle-product');
    allProducts.forEach(product => {
      const sizeButtons = product.querySelectorAll('.product-variant-size-button');
      sizeButtons.forEach(button => {
        button.addEventListener('click', function(e) {
          // Prevent default behavior that might reset color
          e.stopPropagation();
          
          // Only handle size selection
          const productContainer = this.closest('bundle-product');
          if (productContainer) {
            // Track which product is being interacted with for extra image filtering
            const productHandle = productContainer.getAttribute('data-product-handle');
            if (productHandle) {
              window.__lastInteractedProductHandle = productHandle;
            }
            
            productContainer.querySelectorAll('.product-variant-size-button').forEach(btn => {
              btn.classList.remove('selected');
            });
            this.classList.add('selected');
          }
        });
      });
    });
  }

  /**
  *Size swatches fetch
  */
  const cached = {};

  function getProductOptionIndexes(product) {
    let colorIndex = 0;
    let sizeIndex = 1;
    (product.options || []).forEach((name, idx) => {
      const lower = String(name || '').toLowerCase();
      if (lower.includes('color') || lower.includes('colour')) colorIndex = idx;
      if (lower.includes('size')) sizeIndex = idx;
    });
    return { colorIndex, sizeIndex };
  }

  function getVariantOptionByIndex(variant, index) {
    if (index === 0) return variant.option1;
    if (index === 1) return variant.option2;
    if (index === 2) return variant.option3;
    return null;
  }

  function getSelectedSizeLabel(container) {
    const selected = container.querySelector('.product-variant-size-button.selected:not(.hidden)');
    if (!selected) return null;
    return selected.getAttribute('aria-label') || selected.textContent.trim().split(' - ')[0];
  }

  function autoSelectFirstAvailableSize(variantListContainer, preferredSize) {
    setTimeout(() => {
      const sizeButtons = variantListContainer.querySelectorAll('.product-variant-size-button:not(.hidden)');
      let targetButton = null;

      if (preferredSize) {
        for (const button of sizeButtons) {
          const sizeLabel = button.getAttribute('aria-label') || button.textContent.trim().split(' - ')[0];
          if (sizeLabel === preferredSize && !button.disabled && button.getAttribute('data-available') === 'true') {
            targetButton = button;
            break;
          }
        }
      }

      if (!targetButton) {
        for (const button of sizeButtons) {
          if (!button.disabled && button.getAttribute('data-available') === 'true') {
            targetButton = button;
            break;
          }
        }
      }

      if (targetButton) {
        variantListContainer.querySelectorAll('.product-variant-size-button').forEach(btn => btn.classList.remove('selected'));
        targetButton.classList.add('selected');
        const bp = variantListContainer.closest('bundle-product');
        if (bp) {
          const variantInput = bp.querySelector('.product-variant-id');
          if (variantInput) variantInput.value = targetButton.getAttribute('data-variant-id');
        }
      }
    }, 50);
  }

  function sizeSwatchFetch(selectedColor, variantId = null, onlyProduct = null) {
     const productDataEl = document.getElementById('block-products-json');
     if (!productDataEl) return;

     const productData = JSON.parse(productDataEl.textContent);

     const preferredByProduct = new Map();
     document.querySelectorAll('bundle-product').forEach((bp) => {
       const label = getSelectedSizeLabel(bp);
       if (label) preferredByProduct.set(bp, label);
     });

     const updateSizeContainers = (productHandle, productSize) => {
       let lists;
       if (onlyProduct) {
         if (onlyProduct.getAttribute('data-product-handle') !== productHandle) return;
         lists = onlyProduct.querySelectorAll('.product-variant-size-buttons');
       } else {
         lists = document.querySelectorAll(`.${productHandle} .product-variant-size-buttons`);
       }
       lists.forEach((variantListContainer) => {
         const bp = variantListContainer.closest('bundle-product');
         const preferredSize = bp ? preferredByProduct.get(bp) : null;
         variantListContainer.innerHTML = productSize;
         autoSelectFirstAvailableSize(variantListContainer, preferredSize);
       });
     };
   
    for (const productHandle in productData) {
      if (!Object.prototype.hasOwnProperty.call(productData, productHandle)) continue;
      const product = productData[productHandle];
      const { colorIndex, sizeIndex } = getProductOptionIndexes(product);

      let productSize = '<button type="button" class="product-variant-size-button hidden" data-variant-id="" data-price="" data-compare-price="" data-available="false" aria-label=""></button>';

      product.variants.forEach((variant) => {
        if (getVariantOptionByIndex(variant, colorIndex) !== selectedColor) return;
        const sizeValue = getVariantOptionByIndex(variant, sizeIndex);
        if (!sizeValue) return;
        const comparePrice = variant.compare_at_price || '';
        const disabledClass = variant.available ? '' : ' disabled';
        const disabledAttr = variant.available ? '' : ' disabled';
        productSize += `<button type="button" class="product-variant-size-button${disabledClass}" data-variant-id="${variant.id}" data-price="${variant.price}" data-compare-price="${comparePrice}" data-available="${variant.available}" aria-label="${sizeValue}"${disabledAttr}>${sizeValue}</button>`;
      });

      if (variantId && variantId === productHandle) {
        updateSizeContainers(productHandle, productSize);
      } else if (variantId == null) {
        updateSizeContainers(productHandle, productSize);
      }
    }
    maintainSelectedColors();
  }

  // Initialize new functionality
   if (color_selector_type === 'one_color') {
        syncColorsAcrossProducts();
    }
  maintainSelectedColors();

  
  // Function to update product links based on selected variant
  function updateProductLinks(productContainer, variantId) {
    if (!productContainer || !variantId) return;
    
    // Update all links in the product container
    const productLinks = productContainer.querySelectorAll('a');
    productLinks.forEach(link => {
      const baseUrl = link.getAttribute('href').split('?')[0];
      link.setAttribute('href', `${baseUrl}?variant=${variantId}`);
    });
  }

  // Bundle Hotspot Drawer Functionality
  (function initHotspotDrawer() {
    const drawerContainer = document.querySelector('bundle-hotspot-drawer');
    if (!drawerContainer) return;
    
    const drawer = drawerContainer.querySelector('.bundle-hotspot-drawer-container');
    const drawerContent = drawerContainer.querySelector('.bundle-hotspot-drawer');
    const closeBtn = drawerContainer.querySelector('.bundle-hotspot-drawer__close');
    const prevBtn = drawerContainer.querySelector('#bundle-hotspot-drawer-prev');
    const nextBtn = drawerContainer.querySelector('#bundle-hotspot-drawer-next');
    const slidesContainer = drawerContainer.querySelector('#bundle-hotspot-drawer-slides');
    const sliderComponent = drawerContainer.querySelector('.bundle-hotspot-drawer-slider');
    
    // Function to collect enabled hotspots data from current visible hotspots
    function collectHotspots() {
      const hotspots = [];
      const hotspotElements = document.querySelectorAll('#bundle-product-hotspots .bundle-hotspot');
      hotspotElements.forEach((hotspot, idx) => {
        hotspots.push({
          index: hotspot.getAttribute('data-hotspot-index') || String(idx + 1),
          element: hotspot,
          hotspotItem: hotspot._hotspotItem || null
        });
      });
      return hotspots;
    }
    
    let hotspots = collectHotspots();
    let currentHotspotIndex = 0;
    
    // Function to refresh hotspots when bundle card changes
    function refreshHotspots() {
      // Always refresh hotspots data from DOM
      hotspots = collectHotspots();
      
      // If drawer is open, close it first when bundle changes (to avoid showing wrong content)
      if (drawer && drawer.hasAttribute('open')) {
        closeDrawer();
      }
      
      // Reset current index when bundle changes
      currentHotspotIndex = 0;
    }
    
    // Function to open drawer
    function openDrawer(index) {
      // Always refresh hotspots from DOM before opening (ensures current bundle's data)
      hotspots = collectHotspots();
      if (hotspots.length === 0) {
        console.warn('No hotspots available to show in drawer');
        return;
      }
      if (index < 0 || index >= hotspots.length) index = 0;
      currentHotspotIndex = index;

      // Keep <details open> for overlay/accessibility, and animate via a class.
      // This avoids the "2nd time no animation" issue caused by <details> collapsing content (display:none).
      if (!drawer.hasAttribute('open')) drawer.setAttribute('open', '');

      // Reset to "closed" transform state first, then animate to open.
      drawer.classList.remove('is-visible');
      void drawerContent.offsetHeight; // force reflow so transition always triggers

      requestAnimationFrame(() => {
        drawer.classList.add('is-visible');
        document.body.style.overflow = 'hidden';
        updateDrawerContent();
        updateNavigationButtons();
      });
    }
    
    // Function to close drawer
    function closeDrawer() {
      if (!drawer.hasAttribute('open')) return;

      // Start close animation
      drawer.classList.remove('is-visible');
      document.body.style.overflow = '';

      // After the slide animation finishes, remove [open] (so overlay/pointer-events are cleared)
      let done = false;
      const finish = () => {
        if (done) return;
        done = true;
        drawer.removeAttribute('open');
        drawerContent.removeEventListener('transitionend', onEnd);
      };
      const onEnd = (e) => {
        if (e.target !== drawerContent) return;
        finish();
      };

      drawerContent.addEventListener('transitionend', onEnd);
      // Fallback in case transitionend doesn't fire
      setTimeout(finish, 600);
    }
    
    // Function to update drawer content with slider
    function updateDrawerContent() {
      const hotspot = hotspots[currentHotspotIndex];
      if (!hotspot || !hotspot.hotspotItem || !slidesContainer) {
        console.warn(`No hotspot or slides container found at index ${currentHotspotIndex}`);
        return;
      }
      
      // Update header content (heading, richtext, text)
      const headingEl = drawerContainer.querySelector('#bundle-hotspot-drawer-heading');
      const richtextEl = drawerContainer.querySelector('#bundle-hotspot-drawer-richtext');
      const textEl = drawerContainer.querySelector('#bundle-hotspot-drawer-text');
      
      if (headingEl) {
        headingEl.textContent = hotspot.hotspotItem.getAttribute('data-heading') || '';
      }
      if (richtextEl) {
        richtextEl.innerHTML = hotspot.hotspotItem.getAttribute('data-richtext') || '';
      }
      if (textEl) {
        textEl.innerHTML = hotspot.hotspotItem.getAttribute('data-text') || '';
      }
      
      // Clear existing slides
      slidesContainer.innerHTML = '';
      
      // Get all slides from hotspot item
      const slideItems = hotspot.hotspotItem.querySelectorAll('.bundle-hotspot-slide');
      
      if (slideItems.length === 0) {
        console.warn('No slides found for hotspot');
        return;
      }
      
      // Create slide elements
      slideItems.forEach((slideItem, idx) => {
        const slideImage = slideItem.getAttribute('data-image') || '';
        const slideText = slideItem.getAttribute('data-text') || '';
        const slideParagraph = slideItem.getAttribute('data-paragraph') || '';
        
        const slideLi = document.createElement('li');
        slideLi.className = 'bundle-hotspot-drawer-slide slider__slide';
        slideLi.id = `bundle-hotspot-slide-${currentHotspotIndex}-${idx + 1}`;
        
        slideLi.innerHTML = `
          <div class="bundle-hotspot-drawer-slide__image-wrapper">
            <img src="${slideImage}" alt="${slideText}" class="bundle-hotspot-drawer-slide__image" loading="lazy">
          </div>
          <div class="bundle-hotspot-drawer-slide__content">
            <h3 class="bundle-hotspot-drawer-slide__text">${slideText}</h3>
            <div class="bundle-hotspot-drawer-slide__paragraph">${slideParagraph}</div>
          </div>
        `;
        
        slidesContainer.appendChild(slideLi);
      });
      
      // Initialize slider if component exists
      if (sliderComponent && typeof sliderComponent.initializeSlider === 'function') {
        sliderComponent.initializeSlider();
      } else if (sliderComponent) {
        // Trigger slider initialization event
        const event = new CustomEvent('initSlider', { bubbles: true });
        sliderComponent.dispatchEvent(event);
      }
    }
    
    // Function to update navigation buttons
    function updateNavigationButtons() {
      if (prevBtn) {
        prevBtn.disabled = currentHotspotIndex === 0;
      }
      if (nextBtn) {
        nextBtn.disabled = currentHotspotIndex === hotspots.length - 1;
      }
    }
    
    // Function to navigate hotspots
    function navigateHotspot(direction) {
      // Refresh hotspots before navigating (in case bundle changed)
      hotspots = collectHotspots();
      if (hotspots.length === 0) return;
      
      if (direction === 'prev' && currentHotspotIndex > 0) {
        currentHotspotIndex--;
      } else if (direction === 'next' && currentHotspotIndex < hotspots.length - 1) {
        currentHotspotIndex++;
      }
      updateDrawerContent();
      updateNavigationButtons();
    }
    
    // Event listeners - use event delegation since hotspots are dynamically created
    const hotspotsContainer = document.getElementById('bundle-product-hotspots');
    if (hotspotsContainer) {
      hotspotsContainer.addEventListener('click', (e) => {
        const hotspot = e.target.closest('.bundle-hotspot');
        if (!hotspot) return;
        
        // Refresh hotspots array for navigation
        hotspots = collectHotspots();
        
        // Find the index of this hotspot in the array
        const index = hotspots.findIndex(h => h.element === hotspot);
        
        if (index !== -1) {
          openDrawer(index);
        }
      });
    }
    
    if (closeBtn) {
      closeBtn.addEventListener('click', closeDrawer);
    }
    
    if (prevBtn) {
      prevBtn.addEventListener('click', () => navigateHotspot('prev'));
    }
    
    if (nextBtn) {
      nextBtn.addEventListener('click', () => navigateHotspot('next'));
    }
    
    // Close on overlay click
    drawer.addEventListener('click', (e) => {
      if (e.target === drawer) {
        closeDrawer();
      }
    });
    
    // Close on Escape key
    document.addEventListener('keydown', (e) => {
      if (e.key === 'Escape' && drawer.hasAttribute('open')) {
        closeDrawer();
      }
    });
    
  })();
  
  // Accordion Modal Functionality (Mobile Only)
  (function() {
    // Only run on mobile
    if (window.innerWidth > 749) return;
    
    const modal = document.querySelector('#bundle-accordion-modal');
    if (!modal) return;
    const modalPanel = modal.querySelector('.bundle-accordion-modal');
    
    const tabsContainer = document.querySelector('#accordion-modal-tabs');
    const contentContainer = document.querySelector('#accordion-modal-content');
    const closeBtn = document.querySelector('.bundle-accordion-modal__close');
    
    if (!tabsContainer || !contentContainer) return;
    
    let currentCardId = null;
    
    // Function to populate modal with accordion data
    function populateModal(cardId) {
      if (currentCardId === cardId && tabsContainer.children.length > 0) {
        return; // Already populated for this card
      }
      
      const template = document.querySelector(`.bundle-accordion-data[data-card-id="${cardId}"]`);
      if (!template) return;
      
      const items = template.content.querySelectorAll('.accordion-item');
      if (items.length === 0) return;
      
      // Clear existing content
      tabsContainer.innerHTML = '';
      contentContainer.innerHTML = '';
      
      // Populate tabs and content
      items.forEach((item, index) => {
        const title = item.querySelector('.accordion-title')?.textContent || '';
        const content = item.querySelector('.accordion-content')?.innerHTML || '';
        
        if (!title) return;
        
        // Create tab button
        const tabBtn = document.createElement('button');
        tabBtn.className = 'bundle-accordion-modal__tab';
        tabBtn.textContent = title;
        tabBtn.setAttribute('data-tab-index', index);
        tabBtn.addEventListener('click', () => setActiveTab(index));
        tabsContainer.appendChild(tabBtn);
        
        // Create content div
        const contentDiv = document.createElement('div');
        contentDiv.className = 'bundle-accordion-modal__tab-content';
        contentDiv.setAttribute('data-content-index', index);
        contentDiv.innerHTML = content;
        contentContainer.appendChild(contentDiv);
      });
      
      currentCardId = cardId;
    }
    
    // Function to set active tab
    function setActiveTab(index) {
      const tabs = tabsContainer.querySelectorAll('.bundle-accordion-modal__tab');
      const contents = contentContainer.querySelectorAll('.bundle-accordion-modal__tab-content');
      
      tabs.forEach((tab, i) => {
        tab.classList.toggle('active', i === index);
      });
      
      contents.forEach((content, i) => {
        content.classList.toggle('active', i === index);
      });
    }
    
    // Function to open modal with specific accordion tab
    function openAccordionModal(accordionIndex) {
      const activeCard = document.querySelector('.bundle-option-card[aria-selected="true"]');
      const cardId = activeCard ? activeCard.getAttribute('data-option-id') : null;
      
      if (!cardId) return;
      
      // Populate modal with current bundle's accordions
      populateModal(cardId);
      
      // Set active tab
      setActiveTab(accordionIndex);
      
      // Always animate via class (avoids "first time smooth, second time jump")
      if (!modal.hasAttribute('open')) modal.setAttribute('open', '');
      modal.classList.remove('is-visible');
      if (modalPanel) void modalPanel.offsetHeight;
      requestAnimationFrame(() => {
        modal.classList.add('is-visible');
        document.body.style.overflow = 'hidden';
      });
    }
    
    // Function to close modal
    function closeModal() {
      if (!modal.hasAttribute('open')) return;

      modal.classList.remove('is-visible');
      document.body.style.overflow = '';

      let done = false;
      const finish = () => {
        if (done) return;
        done = true;
        modal.removeAttribute('open');
        if (modalPanel) modalPanel.removeEventListener('transitionend', onEnd);
      };
      const onEnd = (e) => {
        if (!modalPanel || e.target !== modalPanel) return;
        finish();
      };

      if (modalPanel) modalPanel.addEventListener('transitionend', onEnd);
      setTimeout(finish, 600);
    }
    
    // Intercept accordion clicks on mobile
    document.addEventListener('click', (e) => {
      if (window.innerWidth > 749) return; // Desktop: use native accordion
      
      const accordionSummary = e.target.closest('.bundle-accordion__summary');
      if (!accordionSummary) return;
      
      e.preventDefault();
      e.stopPropagation();
      
      const accordion = accordionSummary.closest('.bundle-accordion');
      if (!accordion) return;
      
      const accordionIndex = parseInt(accordion.getAttribute('data-accordion-index')) - 1; // Convert to 0-based
      
      if (!isNaN(accordionIndex) && accordionIndex >= 0) {
        openAccordionModal(accordionIndex);
      }
    });
    
    // Close button
    if (closeBtn) {
      closeBtn.addEventListener('click', closeModal);
    }
    
    // Close on overlay click
    modal.addEventListener('click', (e) => {
      if (e.target === modal) {
        closeModal();
      }
    });
    
    // Close on Escape key
    document.addEventListener('keydown', (e) => {
      if (e.key === 'Escape' && modal.hasAttribute('open')) {
        closeModal();
      }
    });
    
    // Reset modal when bundle card changes
    // Listen for bundle option changes
    const originalSetActiveBundleOption = window.setActiveBundleOption;
    if (originalSetActiveBundleOption) {
      const originalFunction = originalSetActiveBundleOption;
      window.setActiveBundleOption = function(id, updateUrl) {
        originalFunction(id, updateUrl);
        currentCardId = null; // Reset to repopulate for new card
      };
    }
    
    // Also listen for card selection changes
    document.addEventListener('click', (e) => {
      const card = e.target.closest('.bundle-option-card');
      if (card && card.getAttribute('aria-selected') === 'true') {
        currentCardId = null; // Reset when new card is selected
      }
    }, true);
  })();
  
  // Accordion Modal (Mobile) - Minimal JavaScript
  (function() {
    if (window.innerWidth > 749) return; // Desktop: use native accordion
    
    const modal = document.querySelector('#bundle-accordion-modal');
    if (!modal) return;
    
    const tabsContainer = document.querySelector('#accordion-modal-tabs');
    const contentContainer = document.querySelector('#accordion-modal-content');
    const closeBtn = document.querySelector('.bundle-accordion-modal__close');
    
    if (!tabsContainer || !contentContainer) return;
    
    let currentCardId = null;
    
    // Function to populate modal with accordion data
    function populateModal(cardId) {
      if (currentCardId === cardId && tabsContainer.children.length > 0) return;
      
      const template = document.querySelector(`.bundle-accordion-data[data-card-id="${cardId}"]`);
      if (!template) return;
      
      const items = template.content.querySelectorAll('.accordion-item');
      if (items.length === 0) return;
      
      // Clear existing content
      tabsContainer.innerHTML = '';
      contentContainer.innerHTML = '';
      
      // Populate tabs and content
      items.forEach((item, index) => {
        const title = item.querySelector('.accordion-title')?.textContent || '';
        const content = item.querySelector('.accordion-content')?.innerHTML || '';
        
        // Create tab button
        const tab = document.createElement('button');
        tab.className = 'bundle-accordion-modal__tab';
        tab.textContent = title;
        tab.setAttribute('data-tab-index', index);
        tab.addEventListener('click', () => setActiveTab(index));
        tabsContainer.appendChild(tab);
        
        // Create content div
        const contentDiv = document.createElement('div');
        contentDiv.className = 'bundle-accordion-modal__tab-content';
        contentDiv.setAttribute('data-content-index', index);
        contentDiv.innerHTML = content;
        contentContainer.appendChild(contentDiv);
      });
      
      currentCardId = cardId;
    }
    
    // Function to set active tab
    function setActiveTab(index) {
      const tabs = tabsContainer.querySelectorAll('.bundle-accordion-modal__tab');
      const contents = contentContainer.querySelectorAll('.bundle-accordion-modal__tab-content');
      
      tabs.forEach((tab, i) => {
        tab.classList.toggle('active', i === index);
      });
      
      contents.forEach((content, i) => {
        content.classList.toggle('active', i === index);
      });
    }
    
    // Function to open modal with specific accordion
    function openAccordionModal(accordionIndex) {
      const activeCard = document.querySelector('.bundle-option-card[aria-selected="true"]');
      const cardId = activeCard ? activeCard.getAttribute('data-option-id') : null;
      
      if (!cardId) return;
      
      // Populate modal with current bundle's accordions
      populateModal(cardId);
      
      // Set active tab
      setActiveTab(accordionIndex);
      
      // Always animate via class (avoids "first time smooth, second time jump")
      if (!modal.hasAttribute('open')) modal.setAttribute('open', '');
      modal.classList.remove('is-visible');
      if (modalPanel) void modalPanel.offsetHeight;
      requestAnimationFrame(() => {
        modal.classList.add('is-visible');
        document.body.style.overflow = 'hidden';
      });
    }
    
    // Function to close modal
    function closeModal() {
      if (!modal.hasAttribute('open')) return;

      modal.classList.remove('is-visible');
      document.body.style.overflow = '';

      let done = false;
      const finish = () => {
        if (done) return;
        done = true;
        modal.removeAttribute('open');
        if (modalPanel) modalPanel.removeEventListener('transitionend', onEnd);
      };
      const onEnd = (e) => {
        if (!modalPanel || e.target !== modalPanel) return;
        finish();
      };

      if (modalPanel) modalPanel.addEventListener('transitionend', onEnd);
      setTimeout(finish, 600);
    }
    
    // Event: Click accordion summary (mobile only)
    document.addEventListener('click', (e) => {
      if (window.innerWidth > 749) return;
      
      const summary = e.target.closest('.bundle-accordion__summary');
      if (!summary) return;
      
      e.preventDefault();
      e.stopPropagation();
      
      const accordion = summary.closest('.bundle-accordion');
      const accordionIndex = parseInt(accordion.getAttribute('data-accordion-index')) - 1; // Convert to 0-based
      
      openAccordionModal(accordionIndex);
    });
    
    // Close button
    if (closeBtn) {
      closeBtn.addEventListener('click', closeModal);
    }
    
    // Close on overlay click
    modal.addEventListener('click', (e) => {
      if (e.target === modal) {
        closeModal();
      }
    });
    
    // Close on Escape key
    document.addEventListener('keydown', (e) => {
      if (e.key === 'Escape' && modal.hasAttribute('open')) {
        closeModal();
      }
    });
  })();
});
